/**
 * Canais PowerFT (MeasureTypeEnum) — gerado a partir do enum C# fornecido.
 *
 * Cada chave corresponde a um MeasureTypeEnum (i32) que identifica o canal
 * no formato XML .ftml dos VCUs PowerFT. O ID numerico esta no array
 * POWERFT_CHANNEL_IDS na mesma posicao do nome em POWERFT_CHANNEL_NAMES.
 *
 * Para cruzar com VisionFT/labels traduzidos, ver vision-ft-channel-labels.ts
 * que faz lookup pelo powerft_id quando disponivel.
 */

/** Nomes dos canais PowerFT em ordem crescente de MeasureTypeEnum id. */
export const POWERFT_CHANNEL_NAMES: readonly string[] = [
  'TPSIndex',
  'MAPIndex',
  'AirTempIndex',
  'EngineTempIndex',
  'OilPressureIndex',
  'FuelPressureIndex',
  'WaterPressureIndex',
  'TwoStepIndex',
  'VBatIndex',
  'Lambda1Index',
  'Lambda2Index',
  'Borb1AIndex',
  'Borb1BIndex',
  'Borb2AIndex',
  'Borb2BIndex',
  'Pedal1Index',
  'Pedal2Index',
  'WastedGatePressureIndex',
  'BurnOutIndex',
  'WheelSpeed1Index',
  'WheelSpeed2Index',
  'Boost1RPMIndex',
  'Boost2RPMIndex',
  'ClutchIndex',
  'RPMIndex',
  'InjBankAIndex',
  'InjBankBIndex',
  'InjBankACil1Index',
  'InjBankACil2Index',
  'InjBankACil3Index',
  'InjBankACil4Index',
  'InjBankACil5Index',
  'InjBankACil6Index',
  'InjBankACil7Index',
  'InjBankACil8Index',
  'InjBankACil9Index',
  'InjBankACil10Index',
  'InjBankACil11Index',
  'InjBankACil12Index',
  'InjBankBCil1Index',
  'InjBankBCil2Index',
  'InjBankBCil3Index',
  'InjBankBCil4Index',
  'InjBankBCil5Index',
  'InjBankBCil6Index',
  'InjBankBCil7Index',
  'InjBankBCil8Index',
  'InjBankBCil9Index',
  'InjBankBCil10Index',
  'InjBankBCil11Index',
  'InjBankBCil12Index',
  'InjAdvanceIndex',
  'DeadTimeBankAIndex',
  'DeadTimeBankBIndex',
  'IgnDwellIndex',
  'IgnAdvanceIndex',
  'IgnCil1AdvanceIndex',
  'IgnCil2AdvanceIndex',
  'IgnCil3AdvanceIndex',
  'IgnCil4AdvanceIndex',
  'IgnCil5AdvanceIndex',
  'IgnCil6AdvanceIndex',
  'IgnCil7AdvanceIndex',
  'IgnCil8AdvanceIndex',
  'IgnCil9AdvanceIndex',
  'IgnCil10AdvanceIndex',
  'IgnCil11AdvanceIndex',
  'IgnCil12AdvanceIndex',
  'IgnRotor1LeadingIndex',
  'IgnRoto1TrailingIndex',
  'IgnRotor2LeadingIndex',
  'IgnRoto2TrailingIndex',
  'IgnRotor3LeadingIndex',
  'IgnRoto3TrailingIndex',
  'IgnRotor4LeadingIndex',
  'IgnRoto4TrailingIndex',
  'ETPS1MotorIndex',
  'ETPS2MotorIndex',
  'StepMotorIndex',
  'IdlePWMIndex',
  'GasPumpIndex',
  'ComVarIndex',
  'BoostIndex',
  'Eletro1Index',
  'Eletro2Index',
  'DryNitro1Index',
  'DryNitro2Index',
  'WetNitro1Index',
  'WetNitro2Index',
  'VPGNDIndex',
  'HbridgeFB1Index',
  'HbridgeFB2Index',
  'StatusEventIndex',
  'InputPinState1Index',
  'OutputPinState1Index',
  'OutputPinState2Index',
  'CPUTempIndex',
  'ACInputIndex',
  'InjBankADutyIndex',
  'InjBankBDutyIndex',
  'IdleActuatorPosIndex',
  'Borb1APWMIndex',
  'Borb1BPWMIndex',
  'Borb2APWMIndex',
  'Borb2BPWMIndex',
  'CustomData1Index',
  'CustomData2Index',
  'CustomData3Index',
  'CustomData4Index',
  'CustomData5Index',
  'CustomData6Index',
  'CustomData7Index',
  'CustomData8Index',
  'CustomData9Index',
  'CustomData10Index',
  'CustomData11Index',
  'DigitalChannelIndex',
  'IgnCutIndex',
  'BoostInputIndex',
  'WheelSpeed_FLIndex',
  'WheelSpeed_FRIndex',
  'WheelSpeed_RLIndex',
  'WheelSpeed_RRIndex',
  'DriveShaftRPMIndex',
  'InputShaftRPMIndex',
  'ActualGearIndex',
  'ThreeStepIndex',
  'IGNCutRPM',
  'WheelSpeed_FrontIndex',
  'WheelSpeed_RearIndex',
  'Launch_Time',
  'Launch_RevRetard',
  'Launch_SpdRetard',
  'Launch_TimedRetard',
  'Launch_TimedEnrich',
  'Gear_Retard',
  'Gear_Enrich',
  'Gear_ChangeRet',
  'ActualGearAnalogIndex',
  'LaunchModeIndex',
  'EngineModeIndex',
  'Generic1Index',
  'Generic2Index',
  'Generic3Index',
  'Generic4Index',
  'Generic5Index',
  'Generic6Index',
  'Generic7Index',
  'Generic8Index',
  'Generic9Index',
  'Generic10Index',
  'LambdaTargetIndex',
  'LambdaCorrectionIndex',
  'DigitalChannel2Index',
  'NitroPressureIndex',
  'ProNitroButtonIndex',
  'ClutchPositionIndex',
  'ActualGearPulseIndex',
  'ClutchPressureIndex',
  'ProNitro_TimeIndex',
  'ProNitro_EnrichIndex',
  'ProNitro_RetardIndex',
  'ProNitro_StateIndex',
  'ProNitro_Press_EnrichIndex',
  'Gear_ChangeEnrichIndex',
  'Nitro_ButtonIndex',
  'Nitro_EnrichRPMIndex',
  'Nitro_EnrichPWMIndex',
  'Nitro_RetardRPMIndex',
  'Nitro_RetardPWMIndex',
  'CamSyncAngleIndex',
  'RPM2Index',
  'BoostCtrler_Target_PressureIndex',
  'BoostCtrler_PressureIndex',
  'DigitalChannel3Index',
  'IgnChannelSplitIndex',
  'YawRateIndex',
  'RideHeightIndex',
  'Wheelie_RetardIndex',
  'DavisProfiler_RetSgnlIndex',
  'DavisProfiler_CutSgnlIndex',
  'DavisProfiler_RetardIndex',
  'Burnout_SwitchIndex',
  'Datalogger_SwitchIndex',
  'LaunchModeValidatedIndex',
  'Disabled_O2Index',
  'Cylinder_1_O2Index',
  'Cylinder_2_O2Index',
  'Cylinder_3_O2Index',
  'Cylinder_4_O2Index',
  'Cylinder_5_O2Index',
  'Cylinder_6_O2Index',
  'Cylinder_7_O2Index',
  'Cylinder_8_O2Index',
  'Cylinder_9_O2Index',
  'Cylinder_10_O2Index',
  'Cylinder_11_O2Index',
  'Cylinder_12_O2Index',
  'Cylinder_13_O2Index',
  'Cylinder_14_O2Index',
  'Cylinder_15_O2Index',
  'Cylinder_16_O2Index',
  'Left_Bank_O2Index',
  'Right_Bank_O2Index',
  'Exhaust_O2Index',
  'Disabled_EGTIndex',
  'Cylinder_1_EGTIndex',
  'Cylinder_2_EGTIndex',
  'Cylinder_3_EGTIndex',
  'Cylinder_4_EGTIndex',
  'Cylinder_5_EGTIndex',
  'Cylinder_6_EGTIndex',
  'Cylinder_7_EGTIndex',
  'Cylinder_8_EGTIndex',
  'Cylinder_9_EGTIndex',
  'Cylinder_10_EGTIndex',
  'Cylinder_11_EGTIndex',
  'Cylinder_12_EGTIndex',
  'Cylinder_13_EGTIndex',
  'Cylinder_14_EGTIndex',
  'Cylinder_15_EGTIndex',
  'Cylinder_16_EGTIndex',
  'Left_Bank_EGTIndex',
  'Right_Bank_EGTIndex',
  'Exhaust_EGTIndex',
  'LambdaNarrowIndex',
  'DisplayRPMIndex',
  'GearChangeOut_Upshift_BtnIndex',
  'GearChangeOut_Reset_BtnIndex',
  'GearChangeOut_Upshift_RetIndex',
  'DeltaTPS_Index',
  'LambdaMF_Index',
  'ACOut_Enrich_Index',
  'RPM_ControlIndex',
  'HbridgeFB3Index',
  'HbridgeFB4Index',
  'BoardTemp1Index',
  'BoardTemp2Index',
  'ACCZIndex',
  'ACCYIndex',
  'ACCXIndex',
  'GyroZIndex',
  'GyroYIndex',
  'GyroXIndex',
  'GravityVectorZIndex',
  'GravityVectorYIndex',
  'GravityVectorXIndex',
  'LinearAccelerationZIndex',
  'LinearAccelerationYIndex',
  'LinearAccelerationXIndex',
  'QuaternionZIndex',
  'QuaternionYIndex',
  'QuaternionXIndex',
  'QuaternionWIndex',
  'PitchIndex',
  'RollIndex',
  'HeadingIndex',
  'GyroDataZIndex',
  'GyroDataYIndex',
  'GyroDataXIndex',
  'MagDataZIndex',
  'MagDataYIndex',
  'MagDataXIndex',
  'AccelDataZIndex',
  'AccelDataYIndex',
  'AccelDataXIndex',
  'GearControlVoltageIndex',
  'StrainGaugePIndex',
  'StrainGaugeNIndex',
  'Analog2V5Index',
  'CustomData12Index',
  'CustomData13Index',
  'CustomData14Index',
  'CustomData15Index',
  'CustomData16Index',
  'CustomData17Index',
  'CustomData18Index',
  'CustomData19Index',
  'CustomData20Index',
  'WstgtCtrl_BoostP_InputIndex',
  'WstgtCtrl_Pressure_InputIndex',
  'WstgtCtrl_TargetIndex',
  'GearController_CutIndex',
  'GearController_RetardIndex',
  'GearController_SensorVoltageIndex',
  'GearController_GearIndex',
  'CAN_TwoStep_SignalIndex',
  'WstgtCtrl_IncPWMIndex',
  'WstgtCtrl_DecPWMIndex',
  'WstgtCtrl_3WayPWMIndex',
  'InjProNitroDutyIndex',
  'TwoStep_ClutchBtnIndex',
  'TransbreakPulse_BtnIndex',
  'TransbreakPulse_PWMIndex',
  'DayNight_SwitchIndex',
  'FuelFlowCil1BankAIndex',
  'FuelFlowCil2BankAIndex',
  'FuelFlowCil3BankAIndex',
  'FuelFlowCil4BankAIndex',
  'FuelFlowCil5BankAIndex',
  'FuelFlowCil6BankAIndex',
  'FuelFlowCil7BankAIndex',
  'FuelFlowCil8BankAIndex',
  'FuelFlowCil9BankAIndex',
  'FuelFlowCil10BankAIndex',
  'FuelFlowCil11BankAIndex',
  'FuelFlowCil12BankAIndex',
  'FuelFlowCil1BankBIndex',
  'FuelFlowCil2BankBIndex',
  'FuelFlowCil3BankBIndex',
  'FuelFlowCil4BankBIndex',
  'FuelFlowCil5BankBIndex',
  'FuelFlowCil6BankBIndex',
  'FuelFlowCil7BankBIndex',
  'FuelFlowCil8BankBIndex',
  'FuelFlowCil9BankBIndex',
  'FuelFlowCil10BankBIndex',
  'FuelFlowCil11BankBIndex',
  'FuelFlowCil12BankBIndex',
  'DutyInjCil1BankAIndex',
  'DutyInjCil2BankAIndex',
  'DutyInjCil3BankAIndex',
  'DutyInjCil4BankAIndex',
  'DutyInjCil5BankAIndex',
  'DutyInjCil6BankAIndex',
  'DutyInjCil7BankAIndex',
  'DutyInjCil8BankAIndex',
  'DutyInjCil9BankAIndex',
  'DutyInjCil10BankAIndex',
  'DutyInjCil11BankAIndex',
  'DutyInjCil12BankAIndex',
  'DutyInjCil1BankBIndex',
  'DutyInjCil2BankBIndex',
  'DutyInjCil3BankBIndex',
  'DutyInjCil4BankBIndex',
  'DutyInjCil5BankBIndex',
  'DutyInjCil6BankBIndex',
  'DutyInjCil7BankBIndex',
  'DutyInjCil8BankBIndex',
  'DutyInjCil9BankBIndex',
  'DutyInjCil10BankBIndex',
  'DutyInjCil11BankBIndex',
  'DutyInjCil12BankBIndex',
  'AccelGIndex',
  'LateralGIndex',
  'PitchAngleIndex',
  'PitchRateAngleIndex',
  'YawAngleIndex',
  'RollAngleIndex',
  'SpeedAccelCalcIndex',
  'DistanceAccelCalcIndex',
  'FuelFlowBankAIndex',
  'FuelFlowBankBIndex',
  'FuelFlowProNitroIndex',
  'DutyNitroEnrichByPWM_AIndex',
  'DutyNitroEnrichByPWM_BIndex',
  'FlowNitroEnrichByPWM_AIndex',
  'FlowNitroEnrichByPWM_BIndex',
  'Shifter5VSensorIndex',
  'RollRateIndex',
  'DashBtn_SwitchIndex',
  'StarterBtn_SwitchIndex',
  'TwoStepMasterSignalIndex',
  'ThreeStepMasterSignalIndex',
  'BurnoutMasterSignalIndex',
  'WheelSpeed_TractionHiResIndex',
  'WheelSpeed_DragHiResIndex',
  'WheelSpeed_FLHiResIndex',
  'WheelSpeed_FRHiResIndex',
  'WheelSpeed_RLHiResIndex',
  'WheelSpeed_RRHiResIndex',
  'WheelSpeed_FrontHiResIndex',
  'WheelSpeed_RearHiResIndex',
  'ExtIgn_Discharge_1Index',
  'ExtIgn_Discharge_2Index',
  'ExtIgn_Discharge_3Index',
  'ExtIgn_Discharge_4Index',
  'ExtIgn_Discharge_5Index',
  'ExtIgn_Discharge_6Index',
  'ExtIgn_Discharge_7Index',
  'ExtIgn_Discharge_8Index',
  'ExtIgn_Discharge_9Index',
  'ExtIgn_Discharge_10Index',
  'ExtIgn_Discharge_11Index',
  'ExtIgn_Discharge_12Index',
  'ExtIgn_PowerSupplyIndex',
  'ExtIgn_PowerSupplyDropIndex',
  'ExtIgn_PowerLevelIndex',
  'ExtIgn_TemperatureIndex',
  'ExtIgn_CapCharge_1Index',
  'ExtIgn_CapCharge_2Index',
  'ExtIgn_CapTime_1Index',
  'ExtIgn_CapTime_2Index',
  'ExtIgn_ErrorCodeIndex',
  'ExtIgn_NoLoadOutsIndex',
  'ExtIgn_PartialDischOutsIndex',
  'ExtIgn_DamagedOutsIndex',
  'ExtIgn_DisabledOutsIndex',
  'ExtIgn_OperationStautsIndex',
  'ExtIgn_EnergyConfigIndex',
  'AccelDataZRAW_Index',
  'AccelDataYRAW_Index',
  'AccelDataXRAW_Index',
  'CamSyncSensorRPMIndex',
  'DiffCtrl_EngPosition_1Index',
  'DiffCtrl_EngPosition_2Index',
  'DiffCtrl_EngPosition_3Index',
  'DiffCtrl_EngPosition_4Index',
  'DiffCtrl_EngPosition_5Index',
  'DiffCtrl_SelPosition_1Index',
  'DiffCtrl_SelPosition_2Index',
  'DiffCtrl_SelPosition_ActualIndex',
  'DiffCtrl_EngPosition_ActualIndex',
  'DiffCtrl_EngTransit_ActualIndex',
  'BrakePressureIndex',
  'LineLock_OutputPWMIndex',
  'NitroPressure_2_Index',
  'ShockSensor_FL_Index',
  'ShockSensor_FR_Index',
  'ShockSensor_RL_Index',
  'ShockSensor_RR_Index',
  'Fuel_Temperature_Index',
  'Fuel_EthanolPerc_Index',
  'PanVaccun_Index',
  'BackPressure_Index',
  'OilTemperature_Index',
  'IntercoolerTemperature_Index',
  'TransmissionTemperature_Index',
  'TransmissionPressure_Index',
  'TorqueConvertPressure_Index',
  'TractionSlip_Index',
  'TractionSlipRate_Index',
  'FlexFuelSensor_Index',
  'Sensor5VIndex',
  'PedalPosIndex',
  'ShockSensorRate_FL_Index',
  'ShockSensorRate_FR_Index',
  'ShockSensorRate_RL_Index',
  'ShockSensorRate_RR_Index',
  'AdjustChangerBtn_Index',
  'Adjust_1_Btn_Index',
  'Adjust_2_Btn_Index',
  'Adjust_3_Btn_Index',
  'Adjust_4_Btn_Index',
  'Adjust_5_Btn_Index',
  'InternalTemp_1_Index',
  'InternalTemp_2_Index',
  'InstantGearIndex',
  'PitLimit_SwitchIndex',
  'Eletro1_PWMIndex',
  'Eletro1_InjEnrichIndex',
  'TractionCtrl_Act_BtnSw_Index',
  'TractionCtrl_Sel_AnalogSw_Index',
  'TractionCtrl_Sel_Table1_Index',
  'TractionCtrl_Sel_Table2_Index',
  'TractionCtrl_Sel_Table3_Index',
  'TractionCtrl_Sel_Table4_Index',
  'TractionCtrl_Sel_Table5_Index',
  'TractionCtrl_Sel_Table6_Index',
  'vago459',
  'vago460',
  'TractionCtrl_Sel_TableUp_Index',
  'TractionCtrl_Sel_TableDown_Index',
  'TractionCtrl_Retard_Index',
  'TractionCtrl_SlipError_Index',
  'TractionCtrl_ETC_Index',
  'TractionCtrl_ReferenceSpd_Index',
  'TractionCtrl_Actual_Table',
  'TireTemperature_FL_Index',
  'TireTemperature_FR_Index',
  'TireTemperature_RL_Index',
  'TireTemperature_RR_Index',
  'TrackTemperature_Index',
  'TractionCtrl_SlipTarget_Index',
  'GenInput_1_Index',
  'GenInput_2_Index',
  'GenInput_3_Index',
  'GenInput_4_Index',
  'GenInput_5_Index',
  'GenInput_6_Index',
  'GenInput_7_Index',
  'GenInput_8_Index',
  'DigitalChannel4Index',
  'LeftTurn_SignalIndex',
  'RightTurn_SignalIndex',
  'LowBeam_SignalIndex',
  'HighBeam_SignalIndex',
  'ExtPnH_PeakTime_1AIndex',
  'ExtPnH_PeakTime_2AIndex',
  'ExtPnH_PeakTime_3AIndex',
  'ExtPnH_PeakTime_4AIndex',
  'ExtPnH_PeakTime_5AIndex',
  'ExtPnH_PeakTime_6AIndex',
  'ExtPnH_PeakTime_7AIndex',
  'ExtPnH_PeakTime_8AIndex',
  'ExtPnH_PeakTime_9AIndex',
  'ExtPnH_PeakTime_10AIndex',
  'ExtPnH_PeakTime_11AIndex',
  'ExtPnH_PeakTime_12AIndex',
  'ExtPnH_PeakTime_1BIndex',
  'ExtPnH_PeakTime_2BIndex',
  'ExtPnH_PeakTime_3BIndex',
  'ExtPnH_PeakTime_4BIndex',
  'ExtPnH_PeakTime_5BIndex',
  'ExtPnH_PeakTime_6BIndex',
  'ExtPnH_PeakTime_7BIndex',
  'ExtPnH_PeakTime_8BIndex',
  'ExtPnH_PeakTime_9BIndex',
  'ExtPnH_PeakTime_10BIndex',
  'ExtPnH_PeakTime_11BIndex',
  'ExtPnH_PeakTime_12BIndex',
  'ExtPnH_V_Vbat_M1Index',
  'ExtPnH_V_Vbat_M2Index',
  'DigitalChannel5Index',
  'ExtIgn_Switch_VoltIndex',
  'ExtIgn_CPU_SupplyIndex',
  'ExtIgn_CPU_TempIndex',
  'ExtIgn_OperTimeIndex',
  'ExtIgn_FlagsIndex',
  'Retard_Randomizer_Index',
  'Flow_PumpA_Index',
  'Flow_PumpB_Index',
  'Flow_ReturnA_Index',
  'Flow_ReturnB_Index',
  'Flow_Util_Total_Index',
  'Flow_Util_A_Index',
  'Flow_Util_B_Index',
  'Flow_Perc_A_Index',
  'Flow_Perc_B_Index',
  'FlexFuel_Inj_Main_Index',
  'FlexFuel_Ign_Main_Index',
  'FlexFuel_Inj_Lambda_Index',
  'MechFuel_SwitchIndex',
  'MechFuel_RetardIndex',
  'Blip_SwichIndex',
  'GearDetect_R_ButtonIndex',
  'GearDetect_D_ButtonIndex',
  'Nitro2_ButtonIndex',
  'Nitro2_EnrichRPMIndex',
  'Nitro2_EnrichPWMIndex',
  'Nitro2_RetardRPMIndex',
  'Nitro2_RetardPWMIndex',
  'VVTI_Intake_1_SensorIndex',
  'VVTI_Exaust_1_SensorIndex',
  'VVTI_Intake_2_SensorIndex',
  'VVTI_Exaust_2_SensorIndex',
  'VVTI_Intake_TargetIndex',
  'VVTI_Exaust_TargetIndex',
  'VVTI_Intake_1_PositionIndex',
  'VVTI_Exaust_1_PositionIndex',
  'VVTI_Intake_2_PositionIndex',
  'VVTI_Exaust_2_PositionIndex',
  'VVTI_Intake_1_PWMIndex',
  'VVTI_Exaust_1_PWMIndex',
  'VVTI_Intake_2_PWMIndex',
  'VVTI_Exaust_2_PWMIndex',
  'FlywheelRPMIndex',
  'DigitalChannel6Index',
  'TurnTeethCountedIndex',
  'AdvancedDiagChannelIndex',
  'EV_Engine_1_RPMIndex',
  'EV_Engine_1_CurrentIndex',
  'EV_Engine_1_VoltageIndex',
  'EV_Engine_1_TorqueIndex',
  'EV_Engine_1_TemperatureIndex',
  'EV_Inverter_1_TemperatureIndex',
  'EV_Engine_2_RPMIndex',
  'EV_Engine_2_CurrentIndex',
  'EV_Engine_2_VoltageIndex',
  'EV_Engine_2_TorqueIndex',
  'EV_Engine_2_TemperatureIndex',
  'EV_Inverter_2_TemperatureIndex',
  'Batery_VoltageIndex',
  'Batery_CurrentIndex',
  'Batery_TemperatureIndex',
  'Batery_ChargeIndex',
  'DownShift_BtnIndex',
  'Shifter_SelectionIndex',
  'Shifter_PosSensorAIndex',
  'Shifter_PosSensorBIndex',
  'Shifter_PosSensorCIndex',
  'Shifter_PosSensorDIndex',
  'Brake_SwitchIndex',
  'Shifter_PosSensorAnlIndex',
  'AutoGearBox_PWM_1Index',
  'AutoGearBox_PWM_2Index',
  'AutoGearBox_PWM_3Index',
  'AutoGearBox_PWM_4Index',
  'AutoGearBox_PWM_5Index',
  'AutoGearBox_PWM_6Index',
  'AutoGearBox_PWM_7Index',
  'AutoGearBox_PWM_8Index',
  'AutoGearBox_PWM_LnPIndex',
  'AutoGearBox_PWM_AccIndex',
  'Lockup_PWMIndex',
  'GearDetect_P_ButtonIndex',
  'GearDetect_N_ButtonIndex',
  'DigitalChannel7Index',
  'Bracket_BumpUpBtn_Index',
  'Bracket_BumpDnBtn_Index',
  'Bracket_SuperBumpBtn_Index',
  'Shifter_PosSensorPWMIndex',
  'MultiFuncButton_1_Index',
  'ExtPnH_Status_1AIndex',
  'ExtPnH_Status_2AIndex',
  'ExtPnH_Status_3AIndex',
  'ExtPnH_Status_4AIndex',
  'ExtPnH_Status_5AIndex',
  'ExtPnH_Status_6AIndex',
  'ExtPnH_Status_7AIndex',
  'ExtPnH_Status_8AIndex',
  'ExtPnH_Status_9AIndex',
  'ExtPnH_Status_10AIndex',
  'ExtPnH_Status_11AIndex',
  'ExtPnH_Status_12AIndex',
  'ExtPnH_Status_1BIndex',
  'ExtPnH_Status_2BIndex',
  'ExtPnH_Status_3BIndex',
  'ExtPnH_Status_4BIndex',
  'ExtPnH_Status_5BIndex',
  'ExtPnH_Status_6BIndex',
  'ExtPnH_Status_7BIndex',
  'ExtPnH_Status_8BIndex',
  'ExtPnH_Status_9BIndex',
  'ExtPnH_Status_10BIndex',
  'ExtPnH_Status_11BIndex',
  'ExtPnH_Status_12BIndex',
  'ExtPnH_PCT_M1_1Index',
  'ExtPnH_PCT_M1_2Index',
  'ExtPnH_PCT_M2_1Index',
  'ExtPnH_PCT_M2_2Index',
  'DigitalChannel8Index',
  'Inj_Fast_DecayIndex',
  'TwoStep_PID_P_ValIndex',
  'TwoStep_PID_I_ValIndex',
  'GearAnalogV_Index',
  'ExtIgn_Discharge_13Index',
  'ExtIgn_Discharge_14Index',
  'ExtIgn_Discharge_15Index',
  'ExtIgn_Discharge_16Index',
  'ExtIgnB_PowerSupplyIndex',
  'ExtIgnB_PowerSupplyDropIndex',
  'ExtIgnB_PowerLevelIndex',
  'ExtIgnB_TemperatureIndex',
  'ExtIgnB_CapCharge_1Index',
  'ExtIgnB_CapCharge_2Index',
  'ExtIgnB_CapTime_1Index',
  'ExtIgnB_CapTime_2Index',
  'ExtIgnB_ErrorCodeIndex',
  'ExtIgnB_NoLoadOutsIndex',
  'ExtIgnB_PartialDischOutsIndex',
  'ExtIgnB_DamagedOutsIndex',
  'ExtIgnB_DisabledOutsIndex',
  'ExtIgnB_OperationStautsIndex',
  'ExtIgnB_Switch_VoltIndex',
  'ExtIgnB_CPU_SupplyIndex',
  'ExtIgnB_CPU_TempIndex',
  'ExtIgnB_OperTimeIndex',
  'ExtIgnB_FlagsIndex',
  'InputExpander_BatIndex',
  'InputExpander_Sensor5VIndex',
  'InputExpander_TempIndex',
  'InputExpander_StatusIndex',
  'P2P_SwitchIndex',
  'WstgtCtrl2_BoostP_InputIndex',
  'WstgtCtrl2_Pressure_InputIndex',
  'WstgtCtrl2_TargetIndex',
  'WstgtCtrl2_IncPWMIndex',
  'WstgtCtrl2_DecPWMIndex',
  'WstgtCtrl2_3WayPWMIndex',
  'ALS_Switch_Index',
  'ALS_Ign_RetardIndex',
  'ALS_Inj_EnrichmentIndex',
  'Interlock_Button_Index',
  'Upshift_Request_Index',
  'Upshift_Validated_Index',
  'Downshift_Request_Index',
  'Downshift_Validated_Index',
  'CompAir_Press_Index',
  'DigitalChannel9Index',
  'EGate_MapTarget_Index',
  'EGate1_Pos_Index',
  'EGate1_PosTarget_Index',
  'EGate1_Temp_Index',
  'EGate1_Flow_Index',
  'EGate1_SpeedRate_Index',
  'EGate2_Pos_Index',
  'EGate2_PosTarget_Index',
  'EGate2_Temp_Index',
  'EGate2_Flow_Index',
  'EGate2_SpeedRate_Index',
  'EGate_BoostP_InputIndex',
  'Egate_MAP_PID_P_Val_Index',
  'Egate_MAP_PID_I_Val_Index',
  'Egate_MAP_PID_D_Val_Index',
  'RPMPeriod_Index',
  'GAPPeriod_Index',
  'Egate_MAP_PID_Sum_Val_Index',
  'ExtIgn_Index',
  'ExtTPSRefA_Index',
  'ExtTPSRefB_Index',
  'ExtIgn_Ign1_Index',
  'ExtIgn_Ign2_Index',
  'ExtIgn_Ign3_Index',
  'ExtIgn_Ign4_Index',
  'ExtIgn_Ign5_Index',
  'ExtIgn_Ign6_Index',
  'ExtIgn_Ign7_Index',
  'ExtIgn_Ign8_Index',
  'ExtPnH_TimeToPeak_1AIndex',
  'ExtPnH_TimeToPeak_2AIndex',
  'ExtPnH_TimeToPeak_3AIndex',
  'ExtPnH_TimeToPeak_4AIndex',
  'ExtPnH_TimeToPeak_5AIndex',
  'ExtPnH_TimeToPeak_6AIndex',
  'ExtPnH_TimeToPeak_7AIndex',
  'ExtPnH_TimeToPeak_8AIndex',
  'ExtPnH_TimeToPeak_9AIndex',
  'ExtPnH_TimeToPeak_10AIndex',
  'ExtPnH_TimeToPeak_11AIndex',
  'ExtPnH_TimeToPeak_12AIndex',
  'ExtPnH_TimeToPeak_1BIndex',
  'ExtPnH_TimeToPeak_2BIndex',
  'ExtPnH_TimeToPeak_3BIndex',
  'ExtPnH_TimeToPeak_4BIndex',
  'ExtPnH_TimeToPeak_5BIndex',
  'ExtPnH_TimeToPeak_6BIndex',
  'ExtPnH_TimeToPeak_7BIndex',
  'ExtPnH_TimeToPeak_8BIndex',
  'ExtPnH_TimeToPeak_9BIndex',
  'ExtPnH_TimeToPeak_10BIndex',
  'ExtPnH_TimeToPeak_11BIndex',
  'ExtPnH_TimeToPeak_12BIndex',
  'ExtPnH_Status_M1_Index',
  'ExtPnH_Status_M2_Index',
  'ExtPnH_StatusIndex_drv1M1',
  'ExtPnH_StatusIndex_drv2M1',
  'ExtPnH_StatusIndex_drv3M1',
  'ExtPnH_StatusIndex_drv4M1',
  'ExtPnH_StatusIndex_drv5M1',
  'ExtPnH_StatusIndex_drv6M1',
  'ExtPnH_StatusIndex_drv7M1',
  'ExtPnH_StatusIndex_drv8M1',
  'ExtPnH_StatusIndex_drv1M2',
  'ExtPnH_StatusIndex_drv2M2',
  'ExtPnH_StatusIndex_drv3M2',
  'ExtPnH_StatusIndex_drv4M2',
  'ExtPnH_StatusIndex_drv5M2',
  'ExtPnH_StatusIndex_drv6M2',
  'ExtPnH_StatusIndex_drv7M2',
  'ExtPnH_StatusIndex_drv8M2',
  'ExtPnH_M1_AlertIndex',
  'ExtPnH_M2_AlertIndex',
  'ExtPnH_M1_PreCrankResult_Index',
  'ExtPnH_M2_PreCrankResult_Index',
  'EGate1_DutyCycle_Index',
  'EGate2_DutyCycle_Index',
  'EngineLoad_Index',
  'eGate_InitialPos_Index',
  'eGate1_InitialPosDiff_Index',
  'eGate2_InitialPosDiff_Index',
  'FuelCalc_FuelLevel_Index',
  'FuelCalc_FuelLevel_Instant_Index',
  'RPM_CAN_Index',
  'FuelCalc_Consu_Total_Index',
  'FuelCalc_Consu_Avg_Index',
  'FuelCalc_Consu_Instant_Index',
  'EnginePower_Index',
  'EngineTorque_Index',
  'FuelCalc_ResetBtn_Index',
  'FuelCalc_Dist_Total_Index',
  'FuelCalc_Autonomy_Index',
  'Bracket_PreStagingBtn_Index',
  'TStop_BumpDownBtn_Index',
  'TStop_BumpUpBtn_Index',
  'TStop_SuperBumpBtn_Index',
  'DigitalChannel10Index',
  'Lockup_OnBtn_Index',
  'Lockup_OffBtn_Index',
  'RPM_Delta_Index',
  'Jsk_RevLever_Index',
  'StarterBtn_On_Index',
  'StarterBtn_Off_Index',
  'WheelAngleIndex',
  'HydroVacuumIndex',
  'EV_ETPSInputIndex',
  'EV_RegenInputIndex',
  'EV_StopGo_BtnIndex',
  'EV_Enable_BtnIndex',
  'EV_TorqueTargetIndex',
  'EV_RegenTargetIndex',
  'EV_Torque_PedalPosIndex',
  'EV_Torque_RPMIndex',
  'EV_Torque_SpeedIndex',
  'EV_Torque_OpenBatteryVoltageIndex',
  'EV_Torque_BatterySOCIndex',
  'EV_Torque_OpenCellVoltageIndex',
  'EV_Torque_TempBatteryIndex',
  'EV_Torque_TempInvIndex',
  'EV_Torque_TempMotorIndex',
  'EV_Regen_PedalPosIndex',
  'EV_Regen_RPMIndex',
  'EV_Regen_SpeedIndex',
  'EV_Regen_OpenBatteryVoltageIndex',
  'EV_Regen_BatterySOCIndex',
  'EV_Regen_OpenCellVoltageIndex',
  'EV_Regen_TempBatteryIndex',
  'EV_Regen_TempInvIndex',
  'EV_Regen_TempMotorIndex',
  'EV_Regen_BrakePressIndex',
  'EV_TorqueRegenPolarityIndex',
  'EV_Battery_DCLValueIndex',
  'EV_Battery_CCLValueIndex',
  'EV_Battery_LowestCellVoltageIndex',
  'EV_Battery_HighestCellVoltageIndex',
  'EV_Battery_LowestCellTempIndex',
  'EV_Battery_HighestCellTempIndex',
  'EV_BMS_StatusFlagsIndex',
  'EV_Inverter_ActualFaultIndex',
  'EV_EnableAll_BtnIndex',
  'EV_InverterPowerUp_BtnIndex',
  'EV_FrontOrBackDirection_BtnIndex',
  'EV_Inverter_TemperatureIndex',
  'EV_Inverter_ActualStateIndex',
  'EV_BreakPedalIndex',
  'EV_EnableAll_KeyPad_Index',
  'EV_FrontOrBackDirection_KeyPad_Index',
  'EV_Battery_PackOpenVoltage_Index',
  'EV_Battery_CellOpenVoltage_Index',
  'EV_ChargeRequestIndex',
  'EV_InverterDcBusVoltageIndex',
  'EV_CurrentStateIndex',
  'EV_CreepingTorqueTargetIndex',
  'EV_ReverseCtrlTorqueTargetIndex',
  'EV_ChargeRequest_BtnIndex',
  'EV_Creeping_P_TermIndex',
  'EV_Creeping_I_TermIndex',
  'EV_Creeping_D_TermIndex',
  'EV_Reverse_P_TermIndex',
  'EV_Reverse_I_TermIndex',
  'EV_Reverse_D_TermIndex',
  'Vago_EV_BatteryVoltageInputIndex',
  'EV_BatteryCurrentInputIndex',
  'EV_PowerIndex',
  'EV_EnergyIndex',
  'EV_MetricsLastTripEfficiencyIndex',
  'EV_MetricsLastChargeEfficiencyIndex',
  'EV_MetricsCurEfficiencyIndex',
  'EV_PowertrainMaxPowerkWIndex',
  'EV_ForwardOrBack_Gauge_Index',
  'EV_Range_km_Index',
  'EV_FaultsBMSIndex',
  'EV_FaultsOBCIndex',
  'EV_FaultsInverterIndex',
  'EVEngModeIndex',
  'EV_Vago5Index',
  'ServoBrakePressIndex',
  'MAF_input_Hz_Index',
  'MAF_input_Unit_Index',
  'MAF_output_Hz_Index',
  'MAF_output_Unit_Index',
  'Lap_Time_Index',
  'Lap_Time_Predicted_Index',
  'O2NanoPro_Temperature_Index',
  'O2NanoPro_Resistence_Index',
  'O2NanoPro_HeaterPwm_Index',
  'NoWAKE_Btn_Index',
  'JetTrim_Index',
  'JetSki_SpeedLimMode_Index',
  'O2NanoPro_Left_Bank_Temp_Index',
  'O2NanoPro_Right_Bank_Temp_Index',
  'O2NanoPro_Cyl_1_Temp_Index',
  'O2NanoPro_Cyl_2_Temp_Index',
  'O2NanoPro_Cyl_3_Temp_Index',
  'O2NanoPro_Cyl_4_Temp_Index',
  'O2NanoPro_Cyl_5_Temp_Index',
  'O2NanoPro_Cyl_6_Temp_Index',
  'O2NanoPro_Cyl_7_Temp_Index',
  'O2NanoPro_Cyl_8_Temp_Index',
  'O2NanoPro_Cyl_9_Temp_Index',
  'O2NanoPro_Cyl_10_Temp_Index',
  'O2NanoPro_Cyl_11_Temp_Index',
  'O2NanoPro_Cyl_12_Temp_Index',
  'O2NanoPro_Left_Bank_Res_Index',
  'O2NanoPro_Right_Bank_Res_Index',
  'O2NanoPro_Cyl_1_Res_Index',
  'O2NanoPro_Cyl_2_Res_Index',
  'O2NanoPro_Cyl_3_Res_Index',
  'O2NanoPro_Cyl_4_Res_Index',
  'O2NanoPro_Cyl_5_Res_Index',
  'O2NanoPro_Cyl_6_Res_Index',
  'O2NanoPro_Cyl_7_Res_Index',
  'O2NanoPro_Cyl_8_Res_Index',
  'O2NanoPro_Cyl_9_Res_Index',
  'O2NanoPro_Cyl_10_Res_Index',
  'O2NanoPro_Cyl_11_Res_Index',
  'O2NanoPro_Cyl_12_Res_Index',
  'O2NanoPro_Left_Bank_PWM_Index',
  'O2NanoPro_Right_Bank_PWM_Index',
  'O2NanoPro_Cyl_1_PWM_Index',
  'O2NanoPro_Cyl_2_PWM_Index',
  'O2NanoPro_Cyl_3_PWM_Index',
  'O2NanoPro_Cyl_4_PWM_Index',
  'O2NanoPro_Cyl_5_PWM_Index',
  'O2NanoPro_Cyl_6_PWM_Index',
  'O2NanoPro_Cyl_7_PWM_Index',
  'O2NanoPro_Cyl_8_PWM_Index',
  'O2NanoPro_Cyl_9_PWM_Index',
  'O2NanoPro_Cyl_10_PWM_Index',
  'O2NanoPro_Cyl_11_PWM_Index',
  'O2NanoPro_Cyl_12_PWM_Index',
  'O2NanoPro_Index',
  'Borb_Sent_Index',
  'Borb2_Sent_Index',
  'WaterTemperature_Index',
  'EV_ChargeCtrlBtnIndex',
  'EV_Torque_ATCIndex',
  'TCU_Nm_clutch1',
  'TCU_Nm_clutch2',
  'TCU_InputShaft1',
  'TCU_InputShaft2',
  'TCU_PressureClutch1',
  'TCU_PressureClutch2',
  'TCU_OilTemp',
  'TCU_ClutchTemp',
  'WMI_Pump_Out_Index',
  'WMI_TankLevel_Index',
  'WMI_Pressure_Index',
  'WMI_Button_Index',
  'WMI_EnrichRPMIndex',
  'WMI_EnrichPWMIndex',
  'WMI_RetardRPMIndex',
  'WMI_RetardPWMIndex',
  'WMI_Purge_Button_Index',
  'TCU_TorqueSend_Index',
  'GCM_SensorVoltage_Index',
  'FuelPressureCompensation_Index',
  'TCU_Torque_Reduction_Req',
  'Traction_AddBoostIndex',
  'Traction_RemoveBoostIndex',
  'GearDetect_M_ButtonIndex',
  'Boost3RPMIndex',
  'Boost4RPMIndex',
  'O2NanoV2_Temperature_Index',
  'O2NanoV2_Resistence_Index',
  'O2NanoV2_HeaterPwm_Index',
  'O2NanoV2_Left_Bank_Temp_Index',
  'O2NanoV2_Right_Bank_Temp_Index',
  'O2NanoV2_Cyl_1_Temp_Index',
  'O2NanoV2_Cyl_2_Temp_Index',
  'O2NanoV2_Cyl_3_Temp_Index',
  'O2NanoV2_Cyl_4_Temp_Index',
  'O2NanoV2_Cyl_5_Temp_Index',
  'O2NanoV2_Cyl_6_Temp_Index',
  'O2NanoV2_Cyl_7_Temp_Index',
  'O2NanoV2_Cyl_8_Temp_Index',
  'O2NanoV2_Cyl_9_Temp_Index',
  'O2NanoV2_Cyl_10_Temp_Index',
  'O2NanoV2_Cyl_11_Temp_Index',
  'O2NanoV2_Cyl_12_Temp_Index',
  'O2NanoV2_Left_Bank_Res_Index',
  'O2NanoV2_Right_Bank_Res_Index',
  'O2NanoV2_Cyl_1_Res_Index',
  'O2NanoV2_Cyl_2_Res_Index',
  'O2NanoV2_Cyl_3_Res_Index',
  'O2NanoV2_Cyl_4_Res_Index',
  'O2NanoV2_Cyl_5_Res_Index',
  'O2NanoV2_Cyl_6_Res_Index',
  'O2NanoV2_Cyl_7_Res_Index',
  'O2NanoV2_Cyl_8_Res_Index',
  'O2NanoV2_Cyl_9_Res_Index',
  'O2NanoV2_Cyl_10_Res_Index',
  'O2NanoV2_Cyl_11_Res_Index',
  'O2NanoV2_Cyl_12_Res_Index',
  'O2NanoV2_Left_Bank_PWM_Index',
  'O2NanoV2_Right_Bank_PWM_Index',
  'O2NanoV2_Cyl_1_PWM_Index',
  'O2NanoV2_Cyl_2_PWM_Index',
  'O2NanoV2_Cyl_3_PWM_Index',
  'O2NanoV2_Cyl_4_PWM_Index',
  'O2NanoV2_Cyl_5_PWM_Index',
  'O2NanoV2_Cyl_6_PWM_Index',
  'O2NanoV2_Cyl_7_PWM_Index',
  'O2NanoV2_Cyl_8_PWM_Index',
  'O2NanoV2_Cyl_9_PWM_Index',
  'O2NanoV2_Cyl_10_PWM_Index',
  'O2NanoV2_Cyl_11_PWM_Index',
  'O2NanoV2_Cyl_12_PWM_Index',
  'Intermed_InputShaftRPM_1_Index',
  'Intermed_InputShaftRPM_2_Index',
  'HandbrakePositionIndex',
  'TwoStep_Digital_Index',
  'BurnOut_Digital_Index',
  'ComVar_Digital_Index',
  'Eletro1_Digital_Index',
  'Eletro2_Digital_Index',
  'AC_In_Digital_Index',
  'AC_Out_Digital_Index',
  'CutOff_Digital_Index',
  'Pump_Digital_Index',
  'MAP_Out_Digital_Index',
  'Gear_Digital_Index',
  'ThreeStep_Digital_Index',
  'GearChange_Digital_Index',
  'ShiftAlertOut_Digital_Index',
  'ProNitroStage_1_Digital_Index',
  'ProNitroStage_2_Digital_Index',
  'ProNitroStage_3_Digital_Index',
  'ProNitroStage_4_Digital_Index',
  'ProNitroStage_5_Digital_Index',
  'ProNitroStage_6_Digital_Index',
  'ProNitroSwitch_Digital_Index',
  'TimeBasedOut_Digital_Index',
  'NitroSwitch_Digital_Index',
  'GapSync_Digital_Index',
  'SyncSensorOK_Digital_Index',
  'Wheelie_Output1_Digital_Index',
  'Wheelie_Output2_Digital_Index',
  'GearChange_Spool_Digital_Index',
  'GearChange_2_Digital_Index',
  'GearChange_3_Digital_Index',
  'GearChange_4_Digital_Index',
  'GearChange_5_Digital_Index',
  'GearChange_6_Digital_Index',
  'GearChange_Upshift_Digital_Index',
  'Gear_Reset_Digital_Index',
  'WstgtCtrl_BoostP_Digital_Index',
  'PWMOutPBtn_Digital_Index',
  'TwoStep_Validated_Digital_Index',
  'TransbreakPulse_Digital_Index',
  'Burnout_Output_Digital_Index',
  'TwoStep_LineLock_Digital_Index',
  'TwoStep_ClutchBtn_Digital_Index',
  'TwoStep_Button_Digital_Index',
  'AuxPump_Digital_Index',
  'RPMBasedOut_Digital_Index',
  'TractCtrl_Table_Digital_Index',
  'ActiveAdjust_Digital_Index',
  'GenInput_1_Digital_Index',
  'GenInput_2_Digital_Index',
  'GenInput_3_Digital_Index',
  'GenInput_4_Digital_Index',
  'GenInput_5_Digital_Index',
  'GenInput_6_Digital_Index',
  'GenInput_7_Digital_Index',
  'GenInput_8_Digital_Index',
  'TractCtrl_Active_Digital_Index',
  'FastInj_Digital_Index',
  'DecayInj_DigitalIndex',
  'CutOffInj_DigitalIndex',
  'Idle_Digital_Index',
  'PostStart_Digital_Index',
  'PitLimit_Digital_Index',
  'MechFuel_Stage1_Digital_Index',
  'MechFuel_Stage2_Digital_Index',
  'MechFuel_Stage3_Digital_Index',
  'MechFuel_Stage4_Digital_Index',
  'MechFuel_Stage5_Digital_Index',
  'MechFuel_Stage6_Digital_Index',
  'MechFuel_Stage7_Digital_Index',
  'MechFuel_Stage8_Digital_Index',
  'MechFuel_Switch_Digital_Index',
  'Nitro2_Switch_Digital_Index',
  'DigitalFTSpark_TriggerDetected',
  'DigitalFTSpark_PowerLevelSignal',
  'DigitalFTSpark_HiPowerMode',
  'GearChange_1_Digital_Index',
  'GearChange_R_Digital_Index',
  'Blip_Digital_Index',
  'GearDetect_D_Digital_Index',
  'GearDetect_R_Digital_Index',
  'CamSync_DecoderOK_Digital_Index',
  'GearChange_7_Digital_Index',
  'GearChange_8_Digital_Index',
  'GearChange_9_Digital_Index',
  'GearChange_10_Digital_Index',
  'DownShift_Digital_Index',
  'ShifterPosA_Digital_Index',
  'ShifterPosB_Digital_Index',
  'ShifterPosC_Digital_Index',
  'ShifterPosD_Digital_Index',
  'BrakeON_Digital_Index',
  'AdvancedDiag_PulseIgnoredByFilter',
  'AdvancedDiag_LostPulse',
  'AdvancedDiag_WheelTimeOut',
  'AdvancedDiag_PhaseTimeOut',
  'AdvancedDiag_WheelTeethTimeOut',
  'MAP_Out_2_Digital_Index',
  'Bracket_BumpUpBtn_Digital_Index',
  'Bracket_BumpDnBtn_Digital_Index',
  'Bracket_SuperBumpBtn_Digital_Index',
  'Bracket_Out_Digital_Index',
  'LaunchDelay_Running_Digital_Index',
  'TwoStep_Delay1_Run_Digital_Index',
  'TwoStep_Delay2_Run_Digital_Index',
  'LaunchDelay_CrossT_Digital_Index',
  'MultiFuncBtn_1_Digital_Index',
  'GenOut_Btn_1_Digital_Index',
  'GenOut_Btn_2_Digital_Index',
  'GenOut_Btn_3_Digital_Index',
  'GenOut_Btn_4_Digital_Index',
  'GenOut_Btn_5_Digital_Index',
  'GenOut_Btn_6_Digital_Index',
  'GenOut_Btn_7_Digital_Index',
  'GenOut_Btn_8_Digital_Index',
  'Engine_Cranking_Digital_Index',
  'Engine_Idle_Digital_Index',
  'Bracket_PreLaunch_Digital_Index',
  'PrimePulse_Digital_Index',
  'P2P_Digital_Index',
  'WstgtCtrl2_BoostP_Digital_Index',
  'ALS_Enabled_Digital_Index',
  'ALS_Button_Digital_Index',
  'ALS_AuxOutput_Digital_Index',
  'AirCompressor_ON_Digital_Index',
  'GChgMngr_Active_Digital_Index',
  'GChgMngr_Up_Digital_Index',
  'GChgMngr_Dn_Digital_Index',
  'GChgMngr_Cut_Digital_Index',
  'GChgMngr_Ign_Digital_Index',
  'GChgMngr_ETC_Digital_Index',
  'GChgMngr_UpOut_Digital_Index',
  'GChgMngr_DnOut_Digital_Index',
  'InterLockBtn_Digital_Index',
  'StarterButton_Digital_Index',
  'EGateBoostPBtn_Digital_Index',
  'ExternalCtrl_Mode_Digital_Index',
  'Egate1_ProtectOn_Digital_Index',
  'Egate2_ProtectOn_Digital_Index',
  'Egate_ClosedLoop_Digital_Index',
  'EGate1_PreLoadOn_Digital_Index',
  'EGate2_PreLoadOn_Digital_Index',
  'TStop_LaunchDelay_Running_Digital_Index',
  'TStop_Timer1_Run_Digital_Index',
  'TStop_Timer2_Run_Digital_Index',
  'Tstop_BumpUpBtn_Digital_Index',
  'Tstop_BumpDnBtn_Digital_Index',
  'Tstop_SupBumpBtn_Digital_Index',
  'Tstop_Out_Digital_Index',
  'Bracket_PreStaging_Digital_Index',
  'NoWake_On_Digital_Index',
  'NoWake_Btn_Digital_Index',
  'EV_DCDC_On_Digital_Index',
  'EV_CAN_RX_BMS_Digital_Index',
  'EV_CAN_RX_OBC_Digital_Index',
  'EV_CAN_RX_Inverter_Digital_Index',
  'ElectronicBlowOff_Out_Digital_Index',
  'WMI_Solenoid_Out_Digital_Index',
  'WMI_Button_Digital_Index',
  'Blip_Out_Digital_Index',
  'TimeBasedEngineShutOff_Digital_Index',
  'CUT_SECURE_MODE_RPM_Index',
  'CUT_HARD_CUT_RPM_Index',
  'CUT_BURNOUT_CUT_RPM_Index',
  'CUT_BURNOUT_LIMIT_RPM_Index',
  'CUT_TWOSTEP_CUT_RPM_Index',
  'CUT_REVLIMITER_CTRL_Index',
  'CUT_EXTERN_LIMIT_Index',
  'CUT_DRVSHFTLIMITER_Index',
  'CUT_THREESTEP_CUT_RPM_Index',
  'CUT_MSDCUTSECURE_RPM_Index',
  'CUT_WHEELIE_CTRL',
  'CUT_DAVIS_CTRL',
  'CUT_GEARCHANGEOUT_CTRL',
  'CUT_GEARCHANGE_CTRL',
  'CUT_PITLIMIT_CTRL',
  'CUT_TRACTION_CTRL',
  'CUT_ALS_CTRL',
  'CUT_GEARCHGMNGR_CTRL',
  'Boost_RetardIndex',
  'Boost_EnrichIndex',
  'OdometerTotalIndex',
  'OdometerPartialIndex',
  'HourmeterTotalIndex',
  'HourmeterPartialIndex',
  'Inputshaft_Compensed_Math',
  'Boost_FuelFlow_Math',
  'FuelFlow_RPM_Math',
  'Flywheel_Clutch_Slip_Math',
  'Flywheel_RPM_Math',
  'FuelDiffPress_Math',
  'FuelFlowTotal_Math',
  'EGT_Average_Math',
  'Clutch_Slip_Math',
  'DiffSpeed_Math',
  'ProNitroStage_Index',
  'Accel_200HZ_Math',
  'Accel_100HZ_Math',
  'Accel_50HZ_Math',
  'Accel_25HZ_Math',
  'Accel_5HZ_Math',
  'Rpm_InputshaftBySpeed_Math',
  'Rpm_InputshaftByDriveShaft_Math',
  'Distance_Math',
  'FlowProNitro',
  'FlowBankA',
  'FlowBankB',
  'Rpm_Driveshaft_Math',
  'DutyBankA',
  'DutyBankB',
];

/** MeasureTypeEnum ids correspondentes a POWERFT_CHANNEL_NAMES (mesmo indice). */
export const POWERFT_CHANNEL_IDS: ReadonlyArray<number> = [
  0,
  1,
  2,
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11,
  12,
  13,
  14,
  15,
  16,
  17,
  18,
  19,
  20,
  21,
  22,
  23,
  24,
  25,
  26,
  27,
  28,
  29,
  30,
  31,
  32,
  33,
  34,
  35,
  36,
  37,
  38,
  39,
  40,
  41,
  42,
  43,
  44,
  45,
  46,
  47,
  48,
  49,
  50,
  51,
  52,
  53,
  54,
  55,
  56,
  57,
  58,
  59,
  60,
  61,
  62,
  63,
  64,
  65,
  66,
  67,
  68,
  69,
  70,
  71,
  72,
  73,
  74,
  75,
  76,
  77,
  78,
  79,
  80,
  81,
  82,
  83,
  84,
  85,
  86,
  87,
  88,
  89,
  90,
  91,
  92,
  93,
  94,
  95,
  96,
  97,
  98,
  99,
  100,
  101,
  102,
  103,
  104,
  105,
  106,
  107,
  108,
  109,
  110,
  111,
  112,
  113,
  114,
  115,
  116,
  117,
  118,
  119,
  120,
  121,
  122,
  123,
  124,
  125,
  126,
  127,
  128,
  129,
  130,
  131,
  132,
  133,
  134,
  135,
  136,
  137,
  138,
  139,
  140,
  141,
  142,
  143,
  144,
  145,
  146,
  147,
  148,
  149,
  150,
  151,
  152,
  153,
  154,
  155,
  156,
  157,
  158,
  159,
  160,
  161,
  162,
  163,
  164,
  165,
  166,
  167,
  168,
  169,
  170,
  171,
  172,
  173,
  174,
  175,
  176,
  177,
  178,
  179,
  180,
  181,
  182,
  183,
  184,
  185,
  186,
  187,
  188,
  189,
  190,
  191,
  192,
  193,
  194,
  195,
  196,
  197,
  198,
  199,
  200,
  201,
  202,
  203,
  204,
  205,
  206,
  207,
  208,
  209,
  210,
  211,
  212,
  213,
  214,
  215,
  216,
  217,
  218,
  219,
  220,
  221,
  222,
  223,
  224,
  225,
  226,
  227,
  228,
  229,
  230,
  231,
  232,
  233,
  234,
  235,
  236,
  237,
  238,
  239,
  240,
  241,
  242,
  243,
  244,
  245,
  246,
  247,
  248,
  249,
  250,
  251,
  252,
  253,
  254,
  255,
  256,
  257,
  258,
  259,
  260,
  261,
  262,
  263,
  264,
  265,
  266,
  267,
  268,
  269,
  270,
  271,
  272,
  273,
  274,
  275,
  276,
  277,
  278,
  279,
  280,
  281,
  282,
  283,
  284,
  285,
  286,
  287,
  288,
  289,
  290,
  291,
  292,
  293,
  294,
  295,
  296,
  297,
  298,
  299,
  300,
  301,
  302,
  303,
  304,
  305,
  306,
  307,
  308,
  309,
  310,
  311,
  312,
  313,
  314,
  315,
  316,
  317,
  318,
  319,
  320,
  321,
  322,
  323,
  324,
  325,
  326,
  327,
  328,
  329,
  330,
  331,
  332,
  333,
  334,
  335,
  336,
  337,
  338,
  339,
  340,
  341,
  342,
  343,
  344,
  345,
  346,
  347,
  348,
  349,
  350,
  351,
  352,
  353,
  354,
  355,
  356,
  357,
  358,
  359,
  360,
  361,
  362,
  363,
  364,
  365,
  366,
  367,
  368,
  369,
  370,
  371,
  372,
  373,
  374,
  375,
  376,
  377,
  378,
  379,
  380,
  381,
  382,
  383,
  384,
  385,
  386,
  387,
  388,
  389,
  390,
  391,
  392,
  393,
  394,
  395,
  396,
  397,
  398,
  399,
  400,
  401,
  402,
  403,
  404,
  405,
  406,
  407,
  408,
  409,
  410,
  411,
  412,
  413,
  414,
  415,
  416,
  417,
  418,
  419,
  420,
  421,
  422,
  423,
  424,
  425,
  426,
  427,
  428,
  429,
  430,
  431,
  432,
  433,
  434,
  435,
  436,
  437,
  438,
  439,
  440,
  441,
  442,
  443,
  444,
  445,
  446,
  447,
  448,
  449,
  450,
  451,
  452,
  453,
  454,
  455,
  456,
  457,
  458,
  459,
  460,
  461,
  462,
  463,
  464,
  465,
  466,
  467,
  468,
  469,
  470,
  471,
  472,
  473,
  474,
  475,
  476,
  477,
  478,
  479,
  480,
  481,
  482,
  483,
  484,
  485,
  486,
  487,
  488,
  489,
  490,
  491,
  492,
  493,
  494,
  495,
  496,
  497,
  498,
  499,
  500,
  501,
  502,
  503,
  504,
  505,
  506,
  507,
  508,
  509,
  510,
  511,
  512,
  513,
  514,
  515,
  516,
  517,
  518,
  519,
  520,
  521,
  522,
  523,
  524,
  525,
  526,
  527,
  528,
  529,
  530,
  531,
  532,
  533,
  534,
  535,
  536,
  537,
  538,
  539,
  540,
  541,
  542,
  543,
  544,
  545,
  546,
  547,
  548,
  549,
  550,
  551,
  552,
  553,
  554,
  555,
  556,
  557,
  558,
  559,
  560,
  561,
  562,
  563,
  564,
  565,
  566,
  567,
  568,
  569,
  570,
  571,
  572,
  573,
  574,
  575,
  576,
  577,
  578,
  579,
  580,
  581,
  582,
  583,
  584,
  585,
  586,
  587,
  588,
  589,
  590,
  591,
  592,
  593,
  594,
  595,
  596,
  597,
  598,
  599,
  600,
  601,
  602,
  603,
  604,
  605,
  606,
  607,
  608,
  609,
  610,
  611,
  612,
  613,
  614,
  615,
  616,
  617,
  618,
  619,
  620,
  621,
  622,
  623,
  624,
  625,
  626,
  627,
  628,
  629,
  630,
  631,
  632,
  633,
  634,
  635,
  636,
  637,
  638,
  639,
  640,
  641,
  642,
  643,
  644,
  645,
  646,
  647,
  648,
  649,
  650,
  651,
  652,
  653,
  654,
  655,
  656,
  657,
  658,
  659,
  660,
  661,
  662,
  663,
  664,
  665,
  666,
  667,
  668,
  669,
  670,
  671,
  672,
  673,
  674,
  675,
  676,
  677,
  678,
  679,
  680,
  681,
  682,
  683,
  684,
  685,
  686,
  687,
  688,
  689,
  690,
  691,
  692,
  693,
  694,
  695,
  696,
  697,
  698,
  699,
  700,
  701,
  702,
  703,
  704,
  705,
  706,
  707,
  708,
  709,
  710,
  711,
  712,
  713,
  714,
  715,
  716,
  717,
  718,
  719,
  720,
  721,
  722,
  723,
  724,
  725,
  726,
  727,
  728,
  729,
  730,
  731,
  732,
  733,
  734,
  735,
  736,
  737,
  738,
  739,
  740,
  741,
  742,
  743,
  744,
  745,
  746,
  747,
  748,
  749,
  750,
  751,
  752,
  753,
  754,
  755,
  756,
  757,
  758,
  759,
  760,
  761,
  762,
  763,
  764,
  765,
  766,
  767,
  768,
  769,
  770,
  771,
  772,
  773,
  774,
  775,
  776,
  777,
  778,
  779,
  780,
  781,
  782,
  783,
  784,
  785,
  786,
  787,
  788,
  789,
  790,
  791,
  792,
  793,
  794,
  795,
  796,
  797,
  798,
  799,
  800,
  801,
  802,
  803,
  804,
  805,
  806,
  807,
  808,
  809,
  810,
  811,
  812,
  813,
  814,
  815,
  816,
  817,
  818,
  819,
  820,
  821,
  822,
  823,
  824,
  825,
  826,
  827,
  828,
  829,
  830,
  831,
  832,
  833,
  834,
  835,
  836,
  837,
  838,
  839,
  840,
  841,
  842,
  843,
  844,
  845,
  846,
  847,
  848,
  849,
  850,
  851,
  852,
  853,
  854,
  855,
  856,
  857,
  858,
  859,
  860,
  861,
  862,
  863,
  864,
  865,
  866,
  867,
  868,
  869,
  870,
  871,
  872,
  873,
  874,
  875,
  876,
  877,
  878,
  879,
  880,
  881,
  882,
  883,
  884,
  885,
  886,
  887,
  888,
  889,
  890,
  891,
  892,
  893,
  894,
  895,
  896,
  897,
  898,
  899,
  900,
  901,
  902,
  903,
  904,
  905,
  906,
  907,
  908,
  909,
  910,
  911,
  912,
  913,
  914,
  915,
  916,
  917,
  918,
  919,
  920,
  921,
  922,
  923,
  924,
  925,
  926,
  927,
  928,
  929,
  930,
  931,
  932,
  933,
  934,
  935,
  936,
  937,
  938,
  939,
  940,
  941,
  942,
  943,
  944,
  945,
  946,
  947,
  948,
  949,
  950,
  951,
  952,
  953,
  954,
  955,
  956,
  957,
  958,
  959,
  960,
  961,
  962,
  963,
  964,
  965,
  966,
  967,
  968,
  969,
  970,
  971,
  972,
  973,
  974,
  975,
  976,
  977,
  978,
  979,
  980,
  981,
  982,
  983,
  984,
  985,
  986,
  987,
  988,
  989,
  990,
  5000,
  5001,
  5002,
  5003,
  5004,
  5005,
  5006,
  5007,
  5008,
  5009,
  5010,
  5011,
  5012,
  5013,
  5014,
  5015,
  5016,
  5017,
  5018,
  5019,
  5020,
  5021,
  5022,
  5023,
  5024,
  5025,
  5026,
  5027,
  5028,
  5029,
  5030,
  5031,
  5032,
  5033,
  5034,
  5035,
  5036,
  5037,
  5038,
  5039,
  5040,
  5041,
  5042,
  5043,
  5044,
  5046,
  5047,
  5048,
  5049,
  5050,
  5051,
  5052,
  5053,
  5054,
  5055,
  5056,
  5057,
  5058,
  5059,
  5060,
  5061,
  5062,
  5063,
  5064,
  5065,
  5066,
  5067,
  5068,
  5069,
  5070,
  5071,
  5072,
  5073,
  5074,
  5075,
  5089,
  5090,
  5091,
  5092,
  5093,
  5094,
  5095,
  5096,
  5097,
  5098,
  5099,
  5100,
  5101,
  5102,
  5103,
  5104,
  5105,
  5106,
  5107,
  5108,
  5109,
  5121,
  5122,
  5123,
  5124,
  5125,
  5126,
  5127,
  5128,
  5129,
  5130,
  5131,
  5132,
  5133,
  5134,
  5135,
  5136,
  5137,
  5138,
  5139,
  5140,
  5141,
  5142,
  5143,
  5144,
  5145,
  5146,
  5147,
  5148,
  5149,
  5150,
  5151,
  5152,
  5153,
  5154,
  5155,
  5156,
  5157,
  5158,
  5159,
  5160,
  5161,
  5162,
  5163,
  5164,
  5165,
  5166,
  5167,
  5168,
  5169,
  5170,
  5171,
  5172,
  5173,
  5174,
  5175,
  5176,
  5177,
  5178,
  5179,
  5180,
  5181,
  5182,
  5183,
  5184,
  7001,
  7002,
  7003,
  7004,
  7005,
  7006,
  7007,
  7008,
  7009,
  7010,
  7011,
  7012,
  7013,
  7014,
  7015,
  7016,
  7017,
  7018,
  60000,
  60001,
  61000,
  61001,
  61002,
  61003,
  65510,
  65511,
  65512,
  65513,
  65514,
  65515,
  65516,
  65517,
  65518,
  65519,
  65520,
  65521,
  65522,
  65523,
  65524,
  65525,
  65526,
  65527,
  65528,
  65529,
  65530,
  65531,
  65532,
  65533,
  65534,
];

/** Lookup direto: id -> nome do canal PowerFT... */
export const POWERFT_NAME_BY_ID: Readonly<Record<number, string>> = {
  0: 'TPSIndex',
  1: 'MAPIndex',
  2: 'AirTempIndex',
  3: 'EngineTempIndex',
  4: 'OilPressureIndex',
  5: 'FuelPressureIndex',
  6: 'WaterPressureIndex',
  7: 'TwoStepIndex',
  8: 'VBatIndex',
  9: 'Lambda1Index',
  10: 'Lambda2Index',
  11: 'Borb1AIndex',
  12: 'Borb1BIndex',
  13: 'Borb2AIndex',
  14: 'Borb2BIndex',
  15: 'Pedal1Index',
  16: 'Pedal2Index',
  17: 'WastedGatePressureIndex',
  18: 'BurnOutIndex',
  19: 'WheelSpeed1Index',
  20: 'WheelSpeed2Index',
  21: 'Boost1RPMIndex',
  22: 'Boost2RPMIndex',
  23: 'ClutchIndex',
  24: 'RPMIndex',
  25: 'InjBankAIndex',
  26: 'InjBankBIndex',
  27: 'InjBankACil1Index',
  28: 'InjBankACil2Index',
  29: 'InjBankACil3Index',
  30: 'InjBankACil4Index',
  31: 'InjBankACil5Index',
  32: 'InjBankACil6Index',
  33: 'InjBankACil7Index',
  34: 'InjBankACil8Index',
  35: 'InjBankACil9Index',
  36: 'InjBankACil10Index',
  37: 'InjBankACil11Index',
  38: 'InjBankACil12Index',
  39: 'InjBankBCil1Index',
  40: 'InjBankBCil2Index',
  41: 'InjBankBCil3Index',
  42: 'InjBankBCil4Index',
  43: 'InjBankBCil5Index',
  44: 'InjBankBCil6Index',
  45: 'InjBankBCil7Index',
  46: 'InjBankBCil8Index',
  47: 'InjBankBCil9Index',
  48: 'InjBankBCil10Index',
  49: 'InjBankBCil11Index',
  50: 'InjBankBCil12Index',
  51: 'InjAdvanceIndex',
  52: 'DeadTimeBankAIndex',
  53: 'DeadTimeBankBIndex',
  54: 'IgnDwellIndex',
  55: 'IgnAdvanceIndex',
  56: 'IgnCil1AdvanceIndex',
  57: 'IgnCil2AdvanceIndex',
  58: 'IgnCil3AdvanceIndex',
  59: 'IgnCil4AdvanceIndex',
  60: 'IgnCil5AdvanceIndex',
  61: 'IgnCil6AdvanceIndex',
  62: 'IgnCil7AdvanceIndex',
  63: 'IgnCil8AdvanceIndex',
  64: 'IgnCil9AdvanceIndex',
  65: 'IgnCil10AdvanceIndex',
  66: 'IgnCil11AdvanceIndex',
  67: 'IgnCil12AdvanceIndex',
  68: 'IgnRotor1LeadingIndex',
  69: 'IgnRoto1TrailingIndex',
  70: 'IgnRotor2LeadingIndex',
  71: 'IgnRoto2TrailingIndex',
  72: 'IgnRotor3LeadingIndex',
  73: 'IgnRoto3TrailingIndex',
  74: 'IgnRotor4LeadingIndex',
  75: 'IgnRoto4TrailingIndex',
  76: 'ETPS1MotorIndex',
  77: 'ETPS2MotorIndex',
  78: 'StepMotorIndex',
  79: 'IdlePWMIndex',
  80: 'GasPumpIndex',
  81: 'ComVarIndex',
  82: 'BoostIndex',
  83: 'Eletro1Index',
  84: 'Eletro2Index',
  85: 'DryNitro1Index',
  86: 'DryNitro2Index',
  87: 'WetNitro1Index',
  88: 'WetNitro2Index',
  89: 'VPGNDIndex',
  90: 'HbridgeFB1Index',
  91: 'HbridgeFB2Index',
  92: 'StatusEventIndex',
  93: 'InputPinState1Index',
  94: 'OutputPinState1Index',
  95: 'OutputPinState2Index',
  96: 'CPUTempIndex',
  97: 'ACInputIndex',
  98: 'InjBankADutyIndex',
  99: 'InjBankBDutyIndex',
  100: 'IdleActuatorPosIndex',
  101: 'Borb1APWMIndex',
  102: 'Borb1BPWMIndex',
  103: 'Borb2APWMIndex',
  104: 'Borb2BPWMIndex',
  105: 'CustomData1Index',
  106: 'CustomData2Index',
  107: 'CustomData3Index',
  108: 'CustomData4Index',
  109: 'CustomData5Index',
  110: 'CustomData6Index',
  111: 'CustomData7Index',
  112: 'CustomData8Index',
  113: 'CustomData9Index',
  114: 'CustomData10Index',
  115: 'CustomData11Index',
  116: 'DigitalChannelIndex',
  117: 'IgnCutIndex',
  118: 'BoostInputIndex',
  119: 'WheelSpeed_FLIndex',
  120: 'WheelSpeed_FRIndex',
  121: 'WheelSpeed_RLIndex',
  122: 'WheelSpeed_RRIndex',
  123: 'DriveShaftRPMIndex',
  124: 'InputShaftRPMIndex',
  125: 'ActualGearIndex',
  126: 'ThreeStepIndex',
  127: 'IGNCutRPM',
  128: 'WheelSpeed_FrontIndex',
  129: 'WheelSpeed_RearIndex',
  130: 'Launch_Time',
  131: 'Launch_RevRetard',
  132: 'Launch_SpdRetard',
  133: 'Launch_TimedRetard',
  134: 'Launch_TimedEnrich',
  135: 'Gear_Retard',
  136: 'Gear_Enrich',
  137: 'Gear_ChangeRet',
  138: 'ActualGearAnalogIndex',
  139: 'LaunchModeIndex',
  140: 'EngineModeIndex',
  141: 'Generic1Index',
  142: 'Generic2Index',
  143: 'Generic3Index',
  144: 'Generic4Index',
  145: 'Generic5Index',
  146: 'Generic6Index',
  147: 'Generic7Index',
  148: 'Generic8Index',
  149: 'Generic9Index',
  150: 'Generic10Index',
  151: 'LambdaTargetIndex',
  152: 'LambdaCorrectionIndex',
  153: 'DigitalChannel2Index',
  154: 'NitroPressureIndex',
  155: 'ProNitroButtonIndex',
  156: 'ClutchPositionIndex',
  157: 'ActualGearPulseIndex',
  158: 'ClutchPressureIndex',
  159: 'ProNitro_TimeIndex',
  160: 'ProNitro_EnrichIndex',
  161: 'ProNitro_RetardIndex',
  162: 'ProNitro_StateIndex',
  163: 'ProNitro_Press_EnrichIndex',
  164: 'Gear_ChangeEnrichIndex',
  165: 'Nitro_ButtonIndex',
  166: 'Nitro_EnrichRPMIndex',
  167: 'Nitro_EnrichPWMIndex',
  168: 'Nitro_RetardRPMIndex',
  169: 'Nitro_RetardPWMIndex',
  170: 'CamSyncAngleIndex',
  171: 'RPM2Index',
  172: 'BoostCtrler_Target_PressureIndex',
  173: 'BoostCtrler_PressureIndex',
  174: 'DigitalChannel3Index',
  175: 'IgnChannelSplitIndex',
  176: 'YawRateIndex',
  177: 'RideHeightIndex',
  178: 'Wheelie_RetardIndex',
  179: 'DavisProfiler_RetSgnlIndex',
  180: 'DavisProfiler_CutSgnlIndex',
  181: 'DavisProfiler_RetardIndex',
  182: 'Burnout_SwitchIndex',
  183: 'Datalogger_SwitchIndex',
  184: 'LaunchModeValidatedIndex',
  185: 'Disabled_O2Index',
  186: 'Cylinder_1_O2Index',
  187: 'Cylinder_2_O2Index',
  188: 'Cylinder_3_O2Index',
  189: 'Cylinder_4_O2Index',
  190: 'Cylinder_5_O2Index',
  191: 'Cylinder_6_O2Index',
  192: 'Cylinder_7_O2Index',
  193: 'Cylinder_8_O2Index',
  194: 'Cylinder_9_O2Index',
  195: 'Cylinder_10_O2Index',
  196: 'Cylinder_11_O2Index',
  197: 'Cylinder_12_O2Index',
  198: 'Cylinder_13_O2Index',
  199: 'Cylinder_14_O2Index',
  200: 'Cylinder_15_O2Index',
  201: 'Cylinder_16_O2Index',
  202: 'Left_Bank_O2Index',
  203: 'Right_Bank_O2Index',
  204: 'Exhaust_O2Index',
  205: 'Disabled_EGTIndex',
  206: 'Cylinder_1_EGTIndex',
  207: 'Cylinder_2_EGTIndex',
  208: 'Cylinder_3_EGTIndex',
  209: 'Cylinder_4_EGTIndex',
  210: 'Cylinder_5_EGTIndex',
  211: 'Cylinder_6_EGTIndex',
  212: 'Cylinder_7_EGTIndex',
  213: 'Cylinder_8_EGTIndex',
  214: 'Cylinder_9_EGTIndex',
  215: 'Cylinder_10_EGTIndex',
  216: 'Cylinder_11_EGTIndex',
  217: 'Cylinder_12_EGTIndex',
  218: 'Cylinder_13_EGTIndex',
  219: 'Cylinder_14_EGTIndex',
  220: 'Cylinder_15_EGTIndex',
  221: 'Cylinder_16_EGTIndex',
  222: 'Left_Bank_EGTIndex',
  223: 'Right_Bank_EGTIndex',
  224: 'Exhaust_EGTIndex',
  225: 'LambdaNarrowIndex',
  226: 'DisplayRPMIndex',
  227: 'GearChangeOut_Upshift_BtnIndex',
  228: 'GearChangeOut_Reset_BtnIndex',
  229: 'GearChangeOut_Upshift_RetIndex',
  230: 'DeltaTPS_Index',
  231: 'LambdaMF_Index',
  232: 'ACOut_Enrich_Index',
  233: 'RPM_ControlIndex',
  234: 'HbridgeFB3Index',
  235: 'HbridgeFB4Index',
  236: 'BoardTemp1Index',
  237: 'BoardTemp2Index',
  238: 'ACCZIndex',
  239: 'ACCYIndex',
  240: 'ACCXIndex',
  241: 'GyroZIndex',
  242: 'GyroYIndex',
  243: 'GyroXIndex',
  244: 'GravityVectorZIndex',
  245: 'GravityVectorYIndex',
  246: 'GravityVectorXIndex',
  247: 'LinearAccelerationZIndex',
  248: 'LinearAccelerationYIndex',
  249: 'LinearAccelerationXIndex',
  250: 'QuaternionZIndex',
  251: 'QuaternionYIndex',
  252: 'QuaternionXIndex',
  253: 'QuaternionWIndex',
  254: 'PitchIndex',
  255: 'RollIndex',
  256: 'HeadingIndex',
  257: 'GyroDataZIndex',
  258: 'GyroDataYIndex',
  259: 'GyroDataXIndex',
  260: 'MagDataZIndex',
  261: 'MagDataYIndex',
  262: 'MagDataXIndex',
  263: 'AccelDataZIndex',
  264: 'AccelDataYIndex',
  265: 'AccelDataXIndex',
  266: 'GearControlVoltageIndex',
  267: 'StrainGaugePIndex',
  268: 'StrainGaugeNIndex',
  269: 'Analog2V5Index',
  270: 'CustomData12Index',
  271: 'CustomData13Index',
  272: 'CustomData14Index',
  273: 'CustomData15Index',
  274: 'CustomData16Index',
  275: 'CustomData17Index',
  276: 'CustomData18Index',
  277: 'CustomData19Index',
  278: 'CustomData20Index',
  279: 'WstgtCtrl_BoostP_InputIndex',
  280: 'WstgtCtrl_Pressure_InputIndex',
  281: 'WstgtCtrl_TargetIndex',
  282: 'GearController_CutIndex',
  283: 'GearController_RetardIndex',
  284: 'GearController_SensorVoltageIndex',
  285: 'GearController_GearIndex',
  286: 'CAN_TwoStep_SignalIndex',
  287: 'WstgtCtrl_IncPWMIndex',
  288: 'WstgtCtrl_DecPWMIndex',
  289: 'WstgtCtrl_3WayPWMIndex',
  290: 'InjProNitroDutyIndex',
  291: 'TwoStep_ClutchBtnIndex',
  292: 'TransbreakPulse_BtnIndex',
  293: 'TransbreakPulse_PWMIndex',
  294: 'DayNight_SwitchIndex',
  295: 'FuelFlowCil1BankAIndex',
  296: 'FuelFlowCil2BankAIndex',
  297: 'FuelFlowCil3BankAIndex',
  298: 'FuelFlowCil4BankAIndex',
  299: 'FuelFlowCil5BankAIndex',
  300: 'FuelFlowCil6BankAIndex',
  301: 'FuelFlowCil7BankAIndex',
  302: 'FuelFlowCil8BankAIndex',
  303: 'FuelFlowCil9BankAIndex',
  304: 'FuelFlowCil10BankAIndex',
  305: 'FuelFlowCil11BankAIndex',
  306: 'FuelFlowCil12BankAIndex',
  307: 'FuelFlowCil1BankBIndex',
  308: 'FuelFlowCil2BankBIndex',
  309: 'FuelFlowCil3BankBIndex',
  310: 'FuelFlowCil4BankBIndex',
  311: 'FuelFlowCil5BankBIndex',
  312: 'FuelFlowCil6BankBIndex',
  313: 'FuelFlowCil7BankBIndex',
  314: 'FuelFlowCil8BankBIndex',
  315: 'FuelFlowCil9BankBIndex',
  316: 'FuelFlowCil10BankBIndex',
  317: 'FuelFlowCil11BankBIndex',
  318: 'FuelFlowCil12BankBIndex',
  319: 'DutyInjCil1BankAIndex',
  320: 'DutyInjCil2BankAIndex',
  321: 'DutyInjCil3BankAIndex',
  322: 'DutyInjCil4BankAIndex',
  323: 'DutyInjCil5BankAIndex',
  324: 'DutyInjCil6BankAIndex',
  325: 'DutyInjCil7BankAIndex',
  326: 'DutyInjCil8BankAIndex',
  327: 'DutyInjCil9BankAIndex',
  328: 'DutyInjCil10BankAIndex',
  329: 'DutyInjCil11BankAIndex',
  330: 'DutyInjCil12BankAIndex',
  331: 'DutyInjCil1BankBIndex',
  332: 'DutyInjCil2BankBIndex',
  333: 'DutyInjCil3BankBIndex',
  334: 'DutyInjCil4BankBIndex',
  335: 'DutyInjCil5BankBIndex',
  336: 'DutyInjCil6BankBIndex',
  337: 'DutyInjCil7BankBIndex',
  338: 'DutyInjCil8BankBIndex',
  339: 'DutyInjCil9BankBIndex',
  340: 'DutyInjCil10BankBIndex',
  341: 'DutyInjCil11BankBIndex',
  342: 'DutyInjCil12BankBIndex',
  343: 'AccelGIndex',
  344: 'LateralGIndex',
  345: 'PitchAngleIndex',
  346: 'PitchRateAngleIndex',
  347: 'YawAngleIndex',
  348: 'RollAngleIndex',
  349: 'SpeedAccelCalcIndex',
  350: 'DistanceAccelCalcIndex',
  351: 'FuelFlowBankAIndex',
  352: 'FuelFlowBankBIndex',
  353: 'FuelFlowProNitroIndex',
  354: 'DutyNitroEnrichByPWM_AIndex',
  355: 'DutyNitroEnrichByPWM_BIndex',
  356: 'FlowNitroEnrichByPWM_AIndex',
  357: 'FlowNitroEnrichByPWM_BIndex',
  358: 'Shifter5VSensorIndex',
  359: 'RollRateIndex',
  360: 'DashBtn_SwitchIndex',
  361: 'StarterBtn_SwitchIndex',
  362: 'TwoStepMasterSignalIndex',
  363: 'ThreeStepMasterSignalIndex',
  364: 'BurnoutMasterSignalIndex',
  365: 'WheelSpeed_TractionHiResIndex',
  366: 'WheelSpeed_DragHiResIndex',
  367: 'WheelSpeed_FLHiResIndex',
  368: 'WheelSpeed_FRHiResIndex',
  369: 'WheelSpeed_RLHiResIndex',
  370: 'WheelSpeed_RRHiResIndex',
  371: 'WheelSpeed_FrontHiResIndex',
  372: 'WheelSpeed_RearHiResIndex',
  373: 'ExtIgn_Discharge_1Index',
  374: 'ExtIgn_Discharge_2Index',
  375: 'ExtIgn_Discharge_3Index',
  376: 'ExtIgn_Discharge_4Index',
  377: 'ExtIgn_Discharge_5Index',
  378: 'ExtIgn_Discharge_6Index',
  379: 'ExtIgn_Discharge_7Index',
  380: 'ExtIgn_Discharge_8Index',
  381: 'ExtIgn_Discharge_9Index',
  382: 'ExtIgn_Discharge_10Index',
  383: 'ExtIgn_Discharge_11Index',
  384: 'ExtIgn_Discharge_12Index',
  385: 'ExtIgn_PowerSupplyIndex',
  386: 'ExtIgn_PowerSupplyDropIndex',
  387: 'ExtIgn_PowerLevelIndex',
  388: 'ExtIgn_TemperatureIndex',
  389: 'ExtIgn_CapCharge_1Index',
  390: 'ExtIgn_CapCharge_2Index',
  391: 'ExtIgn_CapTime_1Index',
  392: 'ExtIgn_CapTime_2Index',
  393: 'ExtIgn_ErrorCodeIndex',
  394: 'ExtIgn_NoLoadOutsIndex',
  395: 'ExtIgn_PartialDischOutsIndex',
  396: 'ExtIgn_DamagedOutsIndex',
  397: 'ExtIgn_DisabledOutsIndex',
  398: 'ExtIgn_OperationStautsIndex',
  399: 'ExtIgn_EnergyConfigIndex',
  400: 'AccelDataZRAW_Index',
  401: 'AccelDataYRAW_Index',
  402: 'AccelDataXRAW_Index',
  403: 'CamSyncSensorRPMIndex',
  404: 'DiffCtrl_EngPosition_1Index',
  405: 'DiffCtrl_EngPosition_2Index',
  406: 'DiffCtrl_EngPosition_3Index',
  407: 'DiffCtrl_EngPosition_4Index',
  408: 'DiffCtrl_EngPosition_5Index',
  409: 'DiffCtrl_SelPosition_1Index',
  410: 'DiffCtrl_SelPosition_2Index',
  411: 'DiffCtrl_SelPosition_ActualIndex',
  412: 'DiffCtrl_EngPosition_ActualIndex',
  413: 'DiffCtrl_EngTransit_ActualIndex',
  414: 'BrakePressureIndex',
  415: 'LineLock_OutputPWMIndex',
  416: 'NitroPressure_2_Index',
  417: 'ShockSensor_FL_Index',
  418: 'ShockSensor_FR_Index',
  419: 'ShockSensor_RL_Index',
  420: 'ShockSensor_RR_Index',
  421: 'Fuel_Temperature_Index',
  422: 'Fuel_EthanolPerc_Index',
  423: 'PanVaccun_Index',
  424: 'BackPressure_Index',
  425: 'OilTemperature_Index',
  426: 'IntercoolerTemperature_Index',
  427: 'TransmissionTemperature_Index',
  428: 'TransmissionPressure_Index',
  429: 'TorqueConvertPressure_Index',
  430: 'TractionSlip_Index',
  431: 'TractionSlipRate_Index',
  432: 'FlexFuelSensor_Index',
  433: 'Sensor5VIndex',
  434: 'PedalPosIndex',
  435: 'ShockSensorRate_FL_Index',
  436: 'ShockSensorRate_FR_Index',
  437: 'ShockSensorRate_RL_Index',
  438: 'ShockSensorRate_RR_Index',
  439: 'AdjustChangerBtn_Index',
  440: 'Adjust_1_Btn_Index',
  441: 'Adjust_2_Btn_Index',
  442: 'Adjust_3_Btn_Index',
  443: 'Adjust_4_Btn_Index',
  444: 'Adjust_5_Btn_Index',
  445: 'InternalTemp_1_Index',
  446: 'InternalTemp_2_Index',
  447: 'InstantGearIndex',
  448: 'PitLimit_SwitchIndex',
  449: 'Eletro1_PWMIndex',
  450: 'Eletro1_InjEnrichIndex',
  451: 'TractionCtrl_Act_BtnSw_Index',
  452: 'TractionCtrl_Sel_AnalogSw_Index',
  453: 'TractionCtrl_Sel_Table1_Index',
  454: 'TractionCtrl_Sel_Table2_Index',
  455: 'TractionCtrl_Sel_Table3_Index',
  456: 'TractionCtrl_Sel_Table4_Index',
  457: 'TractionCtrl_Sel_Table5_Index',
  458: 'TractionCtrl_Sel_Table6_Index',
  459: 'vago459',
  460: 'vago460',
  461: 'TractionCtrl_Sel_TableUp_Index',
  462: 'TractionCtrl_Sel_TableDown_Index',
  463: 'TractionCtrl_Retard_Index',
  464: 'TractionCtrl_SlipError_Index',
  465: 'TractionCtrl_ETC_Index',
  466: 'TractionCtrl_ReferenceSpd_Index',
  467: 'TractionCtrl_Actual_Table',
  468: 'TireTemperature_FL_Index',
  469: 'TireTemperature_FR_Index',
  470: 'TireTemperature_RL_Index',
  471: 'TireTemperature_RR_Index',
  472: 'TrackTemperature_Index',
  473: 'TractionCtrl_SlipTarget_Index',
  474: 'GenInput_1_Index',
  475: 'GenInput_2_Index',
  476: 'GenInput_3_Index',
  477: 'GenInput_4_Index',
  478: 'GenInput_5_Index',
  479: 'GenInput_6_Index',
  480: 'GenInput_7_Index',
  481: 'GenInput_8_Index',
  482: 'DigitalChannel4Index',
  483: 'LeftTurn_SignalIndex',
  484: 'RightTurn_SignalIndex',
  485: 'LowBeam_SignalIndex',
  486: 'HighBeam_SignalIndex',
  487: 'ExtPnH_PeakTime_1AIndex',
  488: 'ExtPnH_PeakTime_2AIndex',
  489: 'ExtPnH_PeakTime_3AIndex',
  490: 'ExtPnH_PeakTime_4AIndex',
  491: 'ExtPnH_PeakTime_5AIndex',
  492: 'ExtPnH_PeakTime_6AIndex',
  493: 'ExtPnH_PeakTime_7AIndex',
  494: 'ExtPnH_PeakTime_8AIndex',
  495: 'ExtPnH_PeakTime_9AIndex',
  496: 'ExtPnH_PeakTime_10AIndex',
  497: 'ExtPnH_PeakTime_11AIndex',
  498: 'ExtPnH_PeakTime_12AIndex',
  499: 'ExtPnH_PeakTime_1BIndex',
  500: 'ExtPnH_PeakTime_2BIndex',
  501: 'ExtPnH_PeakTime_3BIndex',
  502: 'ExtPnH_PeakTime_4BIndex',
  503: 'ExtPnH_PeakTime_5BIndex',
  504: 'ExtPnH_PeakTime_6BIndex',
  505: 'ExtPnH_PeakTime_7BIndex',
  506: 'ExtPnH_PeakTime_8BIndex',
  507: 'ExtPnH_PeakTime_9BIndex',
  508: 'ExtPnH_PeakTime_10BIndex',
  509: 'ExtPnH_PeakTime_11BIndex',
  510: 'ExtPnH_PeakTime_12BIndex',
  511: 'ExtPnH_V_Vbat_M1Index',
  512: 'ExtPnH_V_Vbat_M2Index',
  513: 'DigitalChannel5Index',
  514: 'ExtIgn_Switch_VoltIndex',
  515: 'ExtIgn_CPU_SupplyIndex',
  516: 'ExtIgn_CPU_TempIndex',
  517: 'ExtIgn_OperTimeIndex',
  518: 'ExtIgn_FlagsIndex',
  519: 'Retard_Randomizer_Index',
  520: 'Flow_PumpA_Index',
  521: 'Flow_PumpB_Index',
  522: 'Flow_ReturnA_Index',
  523: 'Flow_ReturnB_Index',
  524: 'Flow_Util_Total_Index',
  525: 'Flow_Util_A_Index',
  526: 'Flow_Util_B_Index',
  527: 'Flow_Perc_A_Index',
  528: 'Flow_Perc_B_Index',
  529: 'FlexFuel_Inj_Main_Index',
  530: 'FlexFuel_Ign_Main_Index',
  531: 'FlexFuel_Inj_Lambda_Index',
  532: 'MechFuel_SwitchIndex',
  533: 'MechFuel_RetardIndex',
  534: 'Blip_SwichIndex',
  535: 'GearDetect_R_ButtonIndex',
  536: 'GearDetect_D_ButtonIndex',
  537: 'Nitro2_ButtonIndex',
  538: 'Nitro2_EnrichRPMIndex',
  539: 'Nitro2_EnrichPWMIndex',
  540: 'Nitro2_RetardRPMIndex',
  541: 'Nitro2_RetardPWMIndex',
  542: 'VVTI_Intake_1_SensorIndex',
  543: 'VVTI_Exaust_1_SensorIndex',
  544: 'VVTI_Intake_2_SensorIndex',
  545: 'VVTI_Exaust_2_SensorIndex',
  546: 'VVTI_Intake_TargetIndex',
  547: 'VVTI_Exaust_TargetIndex',
  548: 'VVTI_Intake_1_PositionIndex',
  549: 'VVTI_Exaust_1_PositionIndex',
  550: 'VVTI_Intake_2_PositionIndex',
  551: 'VVTI_Exaust_2_PositionIndex',
  552: 'VVTI_Intake_1_PWMIndex',
  553: 'VVTI_Exaust_1_PWMIndex',
  554: 'VVTI_Intake_2_PWMIndex',
  555: 'VVTI_Exaust_2_PWMIndex',
  556: 'FlywheelRPMIndex',
  557: 'DigitalChannel6Index',
  558: 'TurnTeethCountedIndex',
  559: 'AdvancedDiagChannelIndex',
  560: 'EV_Engine_1_RPMIndex',
  561: 'EV_Engine_1_CurrentIndex',
  562: 'EV_Engine_1_VoltageIndex',
  563: 'EV_Engine_1_TorqueIndex',
  564: 'EV_Engine_1_TemperatureIndex',
  565: 'EV_Inverter_1_TemperatureIndex',
  566: 'EV_Engine_2_RPMIndex',
  567: 'EV_Engine_2_CurrentIndex',
  568: 'EV_Engine_2_VoltageIndex',
  569: 'EV_Engine_2_TorqueIndex',
  570: 'EV_Engine_2_TemperatureIndex',
  571: 'EV_Inverter_2_TemperatureIndex',
  572: 'Batery_VoltageIndex',
  573: 'Batery_CurrentIndex',
  574: 'Batery_TemperatureIndex',
  575: 'Batery_ChargeIndex',
  576: 'DownShift_BtnIndex',
  577: 'Shifter_SelectionIndex',
  578: 'Shifter_PosSensorAIndex',
  579: 'Shifter_PosSensorBIndex',
  580: 'Shifter_PosSensorCIndex',
  581: 'Shifter_PosSensorDIndex',
  582: 'Brake_SwitchIndex',
  583: 'Shifter_PosSensorAnlIndex',
  584: 'AutoGearBox_PWM_1Index',
  585: 'AutoGearBox_PWM_2Index',
  586: 'AutoGearBox_PWM_3Index',
  587: 'AutoGearBox_PWM_4Index',
  588: 'AutoGearBox_PWM_5Index',
  589: 'AutoGearBox_PWM_6Index',
  590: 'AutoGearBox_PWM_7Index',
  591: 'AutoGearBox_PWM_8Index',
  592: 'AutoGearBox_PWM_LnPIndex',
  593: 'AutoGearBox_PWM_AccIndex',
  594: 'Lockup_PWMIndex',
  595: 'GearDetect_P_ButtonIndex',
  596: 'GearDetect_N_ButtonIndex',
  597: 'DigitalChannel7Index',
  598: 'Bracket_BumpUpBtn_Index',
  599: 'Bracket_BumpDnBtn_Index',
  600: 'Bracket_SuperBumpBtn_Index',
  601: 'Shifter_PosSensorPWMIndex',
  602: 'MultiFuncButton_1_Index',
  603: 'ExtPnH_Status_1AIndex',
  604: 'ExtPnH_Status_2AIndex',
  605: 'ExtPnH_Status_3AIndex',
  606: 'ExtPnH_Status_4AIndex',
  607: 'ExtPnH_Status_5AIndex',
  608: 'ExtPnH_Status_6AIndex',
  609: 'ExtPnH_Status_7AIndex',
  610: 'ExtPnH_Status_8AIndex',
  611: 'ExtPnH_Status_9AIndex',
  612: 'ExtPnH_Status_10AIndex',
  613: 'ExtPnH_Status_11AIndex',
  614: 'ExtPnH_Status_12AIndex',
  615: 'ExtPnH_Status_1BIndex',
  616: 'ExtPnH_Status_2BIndex',
  617: 'ExtPnH_Status_3BIndex',
  618: 'ExtPnH_Status_4BIndex',
  619: 'ExtPnH_Status_5BIndex',
  620: 'ExtPnH_Status_6BIndex',
  621: 'ExtPnH_Status_7BIndex',
  622: 'ExtPnH_Status_8BIndex',
  623: 'ExtPnH_Status_9BIndex',
  624: 'ExtPnH_Status_10BIndex',
  625: 'ExtPnH_Status_11BIndex',
  626: 'ExtPnH_Status_12BIndex',
  627: 'ExtPnH_PCT_M1_1Index',
  628: 'ExtPnH_PCT_M1_2Index',
  629: 'ExtPnH_PCT_M2_1Index',
  630: 'ExtPnH_PCT_M2_2Index',
  631: 'DigitalChannel8Index',
  632: 'Inj_Fast_DecayIndex',
  633: 'TwoStep_PID_P_ValIndex',
  634: 'TwoStep_PID_I_ValIndex',
  635: 'GearAnalogV_Index',
  636: 'ExtIgn_Discharge_13Index',
  637: 'ExtIgn_Discharge_14Index',
  638: 'ExtIgn_Discharge_15Index',
  639: 'ExtIgn_Discharge_16Index',
  640: 'ExtIgnB_PowerSupplyIndex',
  641: 'ExtIgnB_PowerSupplyDropIndex',
  642: 'ExtIgnB_PowerLevelIndex',
  643: 'ExtIgnB_TemperatureIndex',
  644: 'ExtIgnB_CapCharge_1Index',
  645: 'ExtIgnB_CapCharge_2Index',
  646: 'ExtIgnB_CapTime_1Index',
  647: 'ExtIgnB_CapTime_2Index',
  648: 'ExtIgnB_ErrorCodeIndex',
  649: 'ExtIgnB_NoLoadOutsIndex',
  650: 'ExtIgnB_PartialDischOutsIndex',
  651: 'ExtIgnB_DamagedOutsIndex',
  652: 'ExtIgnB_DisabledOutsIndex',
  653: 'ExtIgnB_OperationStautsIndex',
  654: 'ExtIgnB_Switch_VoltIndex',
  655: 'ExtIgnB_CPU_SupplyIndex',
  656: 'ExtIgnB_CPU_TempIndex',
  657: 'ExtIgnB_OperTimeIndex',
  658: 'ExtIgnB_FlagsIndex',
  659: 'InputExpander_BatIndex',
  660: 'InputExpander_Sensor5VIndex',
  661: 'InputExpander_TempIndex',
  662: 'InputExpander_StatusIndex',
  663: 'P2P_SwitchIndex',
  664: 'WstgtCtrl2_BoostP_InputIndex',
  665: 'WstgtCtrl2_Pressure_InputIndex',
  666: 'WstgtCtrl2_TargetIndex',
  667: 'WstgtCtrl2_IncPWMIndex',
  668: 'WstgtCtrl2_DecPWMIndex',
  669: 'WstgtCtrl2_3WayPWMIndex',
  670: 'ALS_Switch_Index',
  671: 'ALS_Ign_RetardIndex',
  672: 'ALS_Inj_EnrichmentIndex',
  673: 'Interlock_Button_Index',
  674: 'Upshift_Request_Index',
  675: 'Upshift_Validated_Index',
  676: 'Downshift_Request_Index',
  677: 'Downshift_Validated_Index',
  678: 'CompAir_Press_Index',
  679: 'DigitalChannel9Index',
  680: 'EGate_MapTarget_Index',
  681: 'EGate1_Pos_Index',
  682: 'EGate1_PosTarget_Index',
  683: 'EGate1_Temp_Index',
  684: 'EGate1_Flow_Index',
  685: 'EGate1_SpeedRate_Index',
  686: 'EGate2_Pos_Index',
  687: 'EGate2_PosTarget_Index',
  688: 'EGate2_Temp_Index',
  689: 'EGate2_Flow_Index',
  690: 'EGate2_SpeedRate_Index',
  691: 'EGate_BoostP_InputIndex',
  692: 'Egate_MAP_PID_P_Val_Index',
  693: 'Egate_MAP_PID_I_Val_Index',
  694: 'Egate_MAP_PID_D_Val_Index',
  695: 'RPMPeriod_Index',
  696: 'GAPPeriod_Index',
  697: 'Egate_MAP_PID_Sum_Val_Index',
  698: 'ExtIgn_Index',
  699: 'ExtTPSRefA_Index',
  700: 'ExtTPSRefB_Index',
  701: 'ExtIgn_Ign1_Index',
  702: 'ExtIgn_Ign2_Index',
  703: 'ExtIgn_Ign3_Index',
  704: 'ExtIgn_Ign4_Index',
  705: 'ExtIgn_Ign5_Index',
  706: 'ExtIgn_Ign6_Index',
  707: 'ExtIgn_Ign7_Index',
  708: 'ExtIgn_Ign8_Index',
  709: 'ExtPnH_TimeToPeak_1AIndex',
  710: 'ExtPnH_TimeToPeak_2AIndex',
  711: 'ExtPnH_TimeToPeak_3AIndex',
  712: 'ExtPnH_TimeToPeak_4AIndex',
  713: 'ExtPnH_TimeToPeak_5AIndex',
  714: 'ExtPnH_TimeToPeak_6AIndex',
  715: 'ExtPnH_TimeToPeak_7AIndex',
  716: 'ExtPnH_TimeToPeak_8AIndex',
  717: 'ExtPnH_TimeToPeak_9AIndex',
  718: 'ExtPnH_TimeToPeak_10AIndex',
  719: 'ExtPnH_TimeToPeak_11AIndex',
  720: 'ExtPnH_TimeToPeak_12AIndex',
  721: 'ExtPnH_TimeToPeak_1BIndex',
  722: 'ExtPnH_TimeToPeak_2BIndex',
  723: 'ExtPnH_TimeToPeak_3BIndex',
  724: 'ExtPnH_TimeToPeak_4BIndex',
  725: 'ExtPnH_TimeToPeak_5BIndex',
  726: 'ExtPnH_TimeToPeak_6BIndex',
  727: 'ExtPnH_TimeToPeak_7BIndex',
  728: 'ExtPnH_TimeToPeak_8BIndex',
  729: 'ExtPnH_TimeToPeak_9BIndex',
  730: 'ExtPnH_TimeToPeak_10BIndex',
  731: 'ExtPnH_TimeToPeak_11BIndex',
  732: 'ExtPnH_TimeToPeak_12BIndex',
  733: 'ExtPnH_Status_M1_Index',
  734: 'ExtPnH_Status_M2_Index',
  735: 'ExtPnH_StatusIndex_drv1M1',
  736: 'ExtPnH_StatusIndex_drv2M1',
  737: 'ExtPnH_StatusIndex_drv3M1',
  738: 'ExtPnH_StatusIndex_drv4M1',
  739: 'ExtPnH_StatusIndex_drv5M1',
  740: 'ExtPnH_StatusIndex_drv6M1',
  741: 'ExtPnH_StatusIndex_drv7M1',
  742: 'ExtPnH_StatusIndex_drv8M1',
  743: 'ExtPnH_StatusIndex_drv1M2',
  744: 'ExtPnH_StatusIndex_drv2M2',
  745: 'ExtPnH_StatusIndex_drv3M2',
  746: 'ExtPnH_StatusIndex_drv4M2',
  747: 'ExtPnH_StatusIndex_drv5M2',
  748: 'ExtPnH_StatusIndex_drv6M2',
  749: 'ExtPnH_StatusIndex_drv7M2',
  750: 'ExtPnH_StatusIndex_drv8M2',
  751: 'ExtPnH_M1_AlertIndex',
  752: 'ExtPnH_M2_AlertIndex',
  753: 'ExtPnH_M1_PreCrankResult_Index',
  754: 'ExtPnH_M2_PreCrankResult_Index',
  755: 'EGate1_DutyCycle_Index',
  756: 'EGate2_DutyCycle_Index',
  757: 'EngineLoad_Index',
  758: 'eGate_InitialPos_Index',
  759: 'eGate1_InitialPosDiff_Index',
  760: 'eGate2_InitialPosDiff_Index',
  761: 'FuelCalc_FuelLevel_Index',
  762: 'FuelCalc_FuelLevel_Instant_Index',
  763: 'RPM_CAN_Index',
  764: 'FuelCalc_Consu_Total_Index',
  765: 'FuelCalc_Consu_Avg_Index',
  766: 'FuelCalc_Consu_Instant_Index',
  767: 'EnginePower_Index',
  768: 'EngineTorque_Index',
  769: 'FuelCalc_ResetBtn_Index',
  770: 'FuelCalc_Dist_Total_Index',
  771: 'FuelCalc_Autonomy_Index',
  772: 'Bracket_PreStagingBtn_Index',
  773: 'TStop_BumpDownBtn_Index',
  774: 'TStop_BumpUpBtn_Index',
  775: 'TStop_SuperBumpBtn_Index',
  776: 'DigitalChannel10Index',
  777: 'Lockup_OnBtn_Index',
  778: 'Lockup_OffBtn_Index',
  779: 'RPM_Delta_Index',
  780: 'Jsk_RevLever_Index',
  781: 'StarterBtn_On_Index',
  782: 'StarterBtn_Off_Index',
  783: 'WheelAngleIndex',
  784: 'HydroVacuumIndex',
  785: 'EV_ETPSInputIndex',
  786: 'EV_RegenInputIndex',
  787: 'EV_StopGo_BtnIndex',
  788: 'EV_Enable_BtnIndex',
  789: 'EV_TorqueTargetIndex',
  790: 'EV_RegenTargetIndex',
  791: 'EV_Torque_PedalPosIndex',
  792: 'EV_Torque_RPMIndex',
  793: 'EV_Torque_SpeedIndex',
  794: 'EV_Torque_OpenBatteryVoltageIndex',
  795: 'EV_Torque_BatterySOCIndex',
  796: 'EV_Torque_OpenCellVoltageIndex',
  797: 'EV_Torque_TempBatteryIndex',
  798: 'EV_Torque_TempInvIndex',
  799: 'EV_Torque_TempMotorIndex',
  800: 'EV_Regen_PedalPosIndex',
  801: 'EV_Regen_RPMIndex',
  802: 'EV_Regen_SpeedIndex',
  803: 'EV_Regen_OpenBatteryVoltageIndex',
  804: 'EV_Regen_BatterySOCIndex',
  805: 'EV_Regen_OpenCellVoltageIndex',
  806: 'EV_Regen_TempBatteryIndex',
  807: 'EV_Regen_TempInvIndex',
  808: 'EV_Regen_TempMotorIndex',
  809: 'EV_Regen_BrakePressIndex',
  810: 'EV_TorqueRegenPolarityIndex',
  811: 'EV_Battery_DCLValueIndex',
  812: 'EV_Battery_CCLValueIndex',
  813: 'EV_Battery_LowestCellVoltageIndex',
  814: 'EV_Battery_HighestCellVoltageIndex',
  815: 'EV_Battery_LowestCellTempIndex',
  816: 'EV_Battery_HighestCellTempIndex',
  817: 'EV_BMS_StatusFlagsIndex',
  818: 'EV_Inverter_ActualFaultIndex',
  819: 'EV_EnableAll_BtnIndex',
  820: 'EV_InverterPowerUp_BtnIndex',
  821: 'EV_FrontOrBackDirection_BtnIndex',
  822: 'EV_Inverter_TemperatureIndex',
  823: 'EV_Inverter_ActualStateIndex',
  824: 'EV_BreakPedalIndex',
  825: 'EV_EnableAll_KeyPad_Index',
  826: 'EV_FrontOrBackDirection_KeyPad_Index',
  827: 'EV_Battery_PackOpenVoltage_Index',
  828: 'EV_Battery_CellOpenVoltage_Index',
  829: 'EV_ChargeRequestIndex',
  830: 'EV_InverterDcBusVoltageIndex',
  831: 'EV_CurrentStateIndex',
  832: 'EV_CreepingTorqueTargetIndex',
  833: 'EV_ReverseCtrlTorqueTargetIndex',
  834: 'EV_ChargeRequest_BtnIndex',
  835: 'EV_Creeping_P_TermIndex',
  836: 'EV_Creeping_I_TermIndex',
  837: 'EV_Creeping_D_TermIndex',
  838: 'EV_Reverse_P_TermIndex',
  839: 'EV_Reverse_I_TermIndex',
  840: 'EV_Reverse_D_TermIndex',
  841: 'Vago_EV_BatteryVoltageInputIndex',
  842: 'EV_BatteryCurrentInputIndex',
  843: 'EV_PowerIndex',
  844: 'EV_EnergyIndex',
  845: 'EV_MetricsLastTripEfficiencyIndex',
  846: 'EV_MetricsLastChargeEfficiencyIndex',
  847: 'EV_MetricsCurEfficiencyIndex',
  848: 'EV_PowertrainMaxPowerkWIndex',
  849: 'EV_ForwardOrBack_Gauge_Index',
  850: 'EV_Range_km_Index',
  851: 'EV_FaultsBMSIndex',
  852: 'EV_FaultsOBCIndex',
  853: 'EV_FaultsInverterIndex',
  854: 'EVEngModeIndex',
  855: 'EV_Vago5Index',
  856: 'ServoBrakePressIndex',
  857: 'MAF_input_Hz_Index',
  858: 'MAF_input_Unit_Index',
  859: 'MAF_output_Hz_Index',
  860: 'MAF_output_Unit_Index',
  861: 'Lap_Time_Index',
  862: 'Lap_Time_Predicted_Index',
  863: 'O2NanoPro_Temperature_Index',
  864: 'O2NanoPro_Resistence_Index',
  865: 'O2NanoPro_HeaterPwm_Index',
  866: 'NoWAKE_Btn_Index',
  867: 'JetTrim_Index',
  868: 'JetSki_SpeedLimMode_Index',
  869: 'O2NanoPro_Left_Bank_Temp_Index',
  870: 'O2NanoPro_Right_Bank_Temp_Index',
  871: 'O2NanoPro_Cyl_1_Temp_Index',
  872: 'O2NanoPro_Cyl_2_Temp_Index',
  873: 'O2NanoPro_Cyl_3_Temp_Index',
  874: 'O2NanoPro_Cyl_4_Temp_Index',
  875: 'O2NanoPro_Cyl_5_Temp_Index',
  876: 'O2NanoPro_Cyl_6_Temp_Index',
  877: 'O2NanoPro_Cyl_7_Temp_Index',
  878: 'O2NanoPro_Cyl_8_Temp_Index',
  879: 'O2NanoPro_Cyl_9_Temp_Index',
  880: 'O2NanoPro_Cyl_10_Temp_Index',
  881: 'O2NanoPro_Cyl_11_Temp_Index',
  882: 'O2NanoPro_Cyl_12_Temp_Index',
  883: 'O2NanoPro_Left_Bank_Res_Index',
  884: 'O2NanoPro_Right_Bank_Res_Index',
  885: 'O2NanoPro_Cyl_1_Res_Index',
  886: 'O2NanoPro_Cyl_2_Res_Index',
  887: 'O2NanoPro_Cyl_3_Res_Index',
  888: 'O2NanoPro_Cyl_4_Res_Index',
  889: 'O2NanoPro_Cyl_5_Res_Index',
  890: 'O2NanoPro_Cyl_6_Res_Index',
  891: 'O2NanoPro_Cyl_7_Res_Index',
  892: 'O2NanoPro_Cyl_8_Res_Index',
  893: 'O2NanoPro_Cyl_9_Res_Index',
  894: 'O2NanoPro_Cyl_10_Res_Index',
  895: 'O2NanoPro_Cyl_11_Res_Index',
  896: 'O2NanoPro_Cyl_12_Res_Index',
  897: 'O2NanoPro_Left_Bank_PWM_Index',
  898: 'O2NanoPro_Right_Bank_PWM_Index',
  899: 'O2NanoPro_Cyl_1_PWM_Index',
  900: 'O2NanoPro_Cyl_2_PWM_Index',
  901: 'O2NanoPro_Cyl_3_PWM_Index',
  902: 'O2NanoPro_Cyl_4_PWM_Index',
  903: 'O2NanoPro_Cyl_5_PWM_Index',
  904: 'O2NanoPro_Cyl_6_PWM_Index',
  905: 'O2NanoPro_Cyl_7_PWM_Index',
  906: 'O2NanoPro_Cyl_8_PWM_Index',
  907: 'O2NanoPro_Cyl_9_PWM_Index',
  908: 'O2NanoPro_Cyl_10_PWM_Index',
  909: 'O2NanoPro_Cyl_11_PWM_Index',
  910: 'O2NanoPro_Cyl_12_PWM_Index',
  911: 'O2NanoPro_Index',
  912: 'Borb_Sent_Index',
  913: 'Borb2_Sent_Index',
  914: 'WaterTemperature_Index',
  915: 'EV_ChargeCtrlBtnIndex',
  916: 'EV_Torque_ATCIndex',
  917: 'TCU_Nm_clutch1',
  918: 'TCU_Nm_clutch2',
  919: 'TCU_InputShaft1',
  920: 'TCU_InputShaft2',
  921: 'TCU_PressureClutch1',
  922: 'TCU_PressureClutch2',
  923: 'TCU_OilTemp',
  924: 'TCU_ClutchTemp',
  925: 'WMI_Pump_Out_Index',
  926: 'WMI_TankLevel_Index',
  927: 'WMI_Pressure_Index',
  928: 'WMI_Button_Index',
  929: 'WMI_EnrichRPMIndex',
  930: 'WMI_EnrichPWMIndex',
  931: 'WMI_RetardRPMIndex',
  932: 'WMI_RetardPWMIndex',
  933: 'WMI_Purge_Button_Index',
  934: 'TCU_TorqueSend_Index',
  935: 'GCM_SensorVoltage_Index',
  936: 'FuelPressureCompensation_Index',
  937: 'TCU_Torque_Reduction_Req',
  938: 'Traction_AddBoostIndex',
  939: 'Traction_RemoveBoostIndex',
  940: 'GearDetect_M_ButtonIndex',
  941: 'Boost3RPMIndex',
  942: 'Boost4RPMIndex',
  943: 'O2NanoV2_Temperature_Index',
  944: 'O2NanoV2_Resistence_Index',
  945: 'O2NanoV2_HeaterPwm_Index',
  946: 'O2NanoV2_Left_Bank_Temp_Index',
  947: 'O2NanoV2_Right_Bank_Temp_Index',
  948: 'O2NanoV2_Cyl_1_Temp_Index',
  949: 'O2NanoV2_Cyl_2_Temp_Index',
  950: 'O2NanoV2_Cyl_3_Temp_Index',
  951: 'O2NanoV2_Cyl_4_Temp_Index',
  952: 'O2NanoV2_Cyl_5_Temp_Index',
  953: 'O2NanoV2_Cyl_6_Temp_Index',
  954: 'O2NanoV2_Cyl_7_Temp_Index',
  955: 'O2NanoV2_Cyl_8_Temp_Index',
  956: 'O2NanoV2_Cyl_9_Temp_Index',
  957: 'O2NanoV2_Cyl_10_Temp_Index',
  958: 'O2NanoV2_Cyl_11_Temp_Index',
  959: 'O2NanoV2_Cyl_12_Temp_Index',
  960: 'O2NanoV2_Left_Bank_Res_Index',
  961: 'O2NanoV2_Right_Bank_Res_Index',
  962: 'O2NanoV2_Cyl_1_Res_Index',
  963: 'O2NanoV2_Cyl_2_Res_Index',
  964: 'O2NanoV2_Cyl_3_Res_Index',
  965: 'O2NanoV2_Cyl_4_Res_Index',
  966: 'O2NanoV2_Cyl_5_Res_Index',
  967: 'O2NanoV2_Cyl_6_Res_Index',
  968: 'O2NanoV2_Cyl_7_Res_Index',
  969: 'O2NanoV2_Cyl_8_Res_Index',
  970: 'O2NanoV2_Cyl_9_Res_Index',
  971: 'O2NanoV2_Cyl_10_Res_Index',
  972: 'O2NanoV2_Cyl_11_Res_Index',
  973: 'O2NanoV2_Cyl_12_Res_Index',
  974: 'O2NanoV2_Left_Bank_PWM_Index',
  975: 'O2NanoV2_Right_Bank_PWM_Index',
  976: 'O2NanoV2_Cyl_1_PWM_Index',
  977: 'O2NanoV2_Cyl_2_PWM_Index',
  978: 'O2NanoV2_Cyl_3_PWM_Index',
  979: 'O2NanoV2_Cyl_4_PWM_Index',
  980: 'O2NanoV2_Cyl_5_PWM_Index',
  981: 'O2NanoV2_Cyl_6_PWM_Index',
  982: 'O2NanoV2_Cyl_7_PWM_Index',
  983: 'O2NanoV2_Cyl_8_PWM_Index',
  984: 'O2NanoV2_Cyl_9_PWM_Index',
  985: 'O2NanoV2_Cyl_10_PWM_Index',
  986: 'O2NanoV2_Cyl_11_PWM_Index',
  987: 'O2NanoV2_Cyl_12_PWM_Index',
  988: 'Intermed_InputShaftRPM_1_Index',
  989: 'Intermed_InputShaftRPM_2_Index',
  990: 'HandbrakePositionIndex',
  5000: 'TwoStep_Digital_Index',
  5001: 'BurnOut_Digital_Index',
  5002: 'ComVar_Digital_Index',
  5003: 'Eletro1_Digital_Index',
  5004: 'Eletro2_Digital_Index',
  5005: 'AC_In_Digital_Index',
  5006: 'AC_Out_Digital_Index',
  5007: 'CutOff_Digital_Index',
  5008: 'Pump_Digital_Index',
  5009: 'MAP_Out_Digital_Index',
  5010: 'Gear_Digital_Index',
  5011: 'ThreeStep_Digital_Index',
  5012: 'GearChange_Digital_Index',
  5013: 'ShiftAlertOut_Digital_Index',
  5014: 'ProNitroStage_1_Digital_Index',
  5015: 'ProNitroStage_2_Digital_Index',
  5016: 'ProNitroStage_3_Digital_Index',
  5017: 'ProNitroStage_4_Digital_Index',
  5018: 'ProNitroStage_5_Digital_Index',
  5019: 'ProNitroStage_6_Digital_Index',
  5020: 'ProNitroSwitch_Digital_Index',
  5021: 'TimeBasedOut_Digital_Index',
  5022: 'NitroSwitch_Digital_Index',
  5023: 'GapSync_Digital_Index',
  5024: 'SyncSensorOK_Digital_Index',
  5025: 'Wheelie_Output1_Digital_Index',
  5026: 'Wheelie_Output2_Digital_Index',
  5027: 'GearChange_Spool_Digital_Index',
  5028: 'GearChange_2_Digital_Index',
  5029: 'GearChange_3_Digital_Index',
  5030: 'GearChange_4_Digital_Index',
  5031: 'GearChange_5_Digital_Index',
  5032: 'GearChange_6_Digital_Index',
  5033: 'GearChange_Upshift_Digital_Index',
  5034: 'Gear_Reset_Digital_Index',
  5035: 'WstgtCtrl_BoostP_Digital_Index',
  5036: 'PWMOutPBtn_Digital_Index',
  5037: 'TwoStep_Validated_Digital_Index',
  5038: 'TransbreakPulse_Digital_Index',
  5039: 'Burnout_Output_Digital_Index',
  5040: 'TwoStep_LineLock_Digital_Index',
  5041: 'TwoStep_ClutchBtn_Digital_Index',
  5042: 'TwoStep_Button_Digital_Index',
  5043: 'AuxPump_Digital_Index',
  5044: 'RPMBasedOut_Digital_Index',
  5046: 'TractCtrl_Table_Digital_Index',
  5047: 'ActiveAdjust_Digital_Index',
  5048: 'GenInput_1_Digital_Index',
  5049: 'GenInput_2_Digital_Index',
  5050: 'GenInput_3_Digital_Index',
  5051: 'GenInput_4_Digital_Index',
  5052: 'GenInput_5_Digital_Index',
  5053: 'GenInput_6_Digital_Index',
  5054: 'GenInput_7_Digital_Index',
  5055: 'GenInput_8_Digital_Index',
  5056: 'TractCtrl_Active_Digital_Index',
  5057: 'FastInj_Digital_Index',
  5058: 'DecayInj_DigitalIndex',
  5059: 'CutOffInj_DigitalIndex',
  5060: 'Idle_Digital_Index',
  5061: 'PostStart_Digital_Index',
  5062: 'PitLimit_Digital_Index',
  5063: 'MechFuel_Stage1_Digital_Index',
  5064: 'MechFuel_Stage2_Digital_Index',
  5065: 'MechFuel_Stage3_Digital_Index',
  5066: 'MechFuel_Stage4_Digital_Index',
  5067: 'MechFuel_Stage5_Digital_Index',
  5068: 'MechFuel_Stage6_Digital_Index',
  5069: 'MechFuel_Stage7_Digital_Index',
  5070: 'MechFuel_Stage8_Digital_Index',
  5071: 'MechFuel_Switch_Digital_Index',
  5072: 'Nitro2_Switch_Digital_Index',
  5073: 'DigitalFTSpark_TriggerDetected',
  5074: 'DigitalFTSpark_PowerLevelSignal',
  5075: 'DigitalFTSpark_HiPowerMode',
  5089: 'GearChange_1_Digital_Index',
  5090: 'GearChange_R_Digital_Index',
  5091: 'Blip_Digital_Index',
  5092: 'GearDetect_D_Digital_Index',
  5093: 'GearDetect_R_Digital_Index',
  5094: 'CamSync_DecoderOK_Digital_Index',
  5095: 'GearChange_7_Digital_Index',
  5096: 'GearChange_8_Digital_Index',
  5097: 'GearChange_9_Digital_Index',
  5098: 'GearChange_10_Digital_Index',
  5099: 'DownShift_Digital_Index',
  5100: 'ShifterPosA_Digital_Index',
  5101: 'ShifterPosB_Digital_Index',
  5102: 'ShifterPosC_Digital_Index',
  5103: 'ShifterPosD_Digital_Index',
  5104: 'BrakeON_Digital_Index',
  5105: 'AdvancedDiag_PulseIgnoredByFilter',
  5106: 'AdvancedDiag_LostPulse',
  5107: 'AdvancedDiag_WheelTimeOut',
  5108: 'AdvancedDiag_PhaseTimeOut',
  5109: 'AdvancedDiag_WheelTeethTimeOut',
  5121: 'MAP_Out_2_Digital_Index',
  5122: 'Bracket_BumpUpBtn_Digital_Index',
  5123: 'Bracket_BumpDnBtn_Digital_Index',
  5124: 'Bracket_SuperBumpBtn_Digital_Index',
  5125: 'Bracket_Out_Digital_Index',
  5126: 'LaunchDelay_Running_Digital_Index',
  5127: 'TwoStep_Delay1_Run_Digital_Index',
  5128: 'TwoStep_Delay2_Run_Digital_Index',
  5129: 'LaunchDelay_CrossT_Digital_Index',
  5130: 'MultiFuncBtn_1_Digital_Index',
  5131: 'GenOut_Btn_1_Digital_Index',
  5132: 'GenOut_Btn_2_Digital_Index',
  5133: 'GenOut_Btn_3_Digital_Index',
  5134: 'GenOut_Btn_4_Digital_Index',
  5135: 'GenOut_Btn_5_Digital_Index',
  5136: 'GenOut_Btn_6_Digital_Index',
  5137: 'GenOut_Btn_7_Digital_Index',
  5138: 'GenOut_Btn_8_Digital_Index',
  5139: 'Engine_Cranking_Digital_Index',
  5140: 'Engine_Idle_Digital_Index',
  5141: 'Bracket_PreLaunch_Digital_Index',
  5142: 'PrimePulse_Digital_Index',
  5143: 'P2P_Digital_Index',
  5144: 'WstgtCtrl2_BoostP_Digital_Index',
  5145: 'ALS_Enabled_Digital_Index',
  5146: 'ALS_Button_Digital_Index',
  5147: 'ALS_AuxOutput_Digital_Index',
  5148: 'AirCompressor_ON_Digital_Index',
  5149: 'GChgMngr_Active_Digital_Index',
  5150: 'GChgMngr_Up_Digital_Index',
  5151: 'GChgMngr_Dn_Digital_Index',
  5152: 'GChgMngr_Cut_Digital_Index',
  5153: 'GChgMngr_Ign_Digital_Index',
  5154: 'GChgMngr_ETC_Digital_Index',
  5155: 'GChgMngr_UpOut_Digital_Index',
  5156: 'GChgMngr_DnOut_Digital_Index',
  5157: 'InterLockBtn_Digital_Index',
  5158: 'StarterButton_Digital_Index',
  5159: 'EGateBoostPBtn_Digital_Index',
  5160: 'ExternalCtrl_Mode_Digital_Index',
  5161: 'Egate1_ProtectOn_Digital_Index',
  5162: 'Egate2_ProtectOn_Digital_Index',
  5163: 'Egate_ClosedLoop_Digital_Index',
  5164: 'EGate1_PreLoadOn_Digital_Index',
  5165: 'EGate2_PreLoadOn_Digital_Index',
  5166: 'TStop_LaunchDelay_Running_Digital_Index',
  5167: 'TStop_Timer1_Run_Digital_Index',
  5168: 'TStop_Timer2_Run_Digital_Index',
  5169: 'Tstop_BumpUpBtn_Digital_Index',
  5170: 'Tstop_BumpDnBtn_Digital_Index',
  5171: 'Tstop_SupBumpBtn_Digital_Index',
  5172: 'Tstop_Out_Digital_Index',
  5173: 'Bracket_PreStaging_Digital_Index',
  5174: 'NoWake_On_Digital_Index',
  5175: 'NoWake_Btn_Digital_Index',
  5176: 'EV_DCDC_On_Digital_Index',
  5177: 'EV_CAN_RX_BMS_Digital_Index',
  5178: 'EV_CAN_RX_OBC_Digital_Index',
  5179: 'EV_CAN_RX_Inverter_Digital_Index',
  5180: 'ElectronicBlowOff_Out_Digital_Index',
  5181: 'WMI_Solenoid_Out_Digital_Index',
  5182: 'WMI_Button_Digital_Index',
  5183: 'Blip_Out_Digital_Index',
  5184: 'TimeBasedEngineShutOff_Digital_Index',
  7001: 'CUT_SECURE_MODE_RPM_Index',
  7002: 'CUT_HARD_CUT_RPM_Index',
  7003: 'CUT_BURNOUT_CUT_RPM_Index',
  7004: 'CUT_BURNOUT_LIMIT_RPM_Index',
  7005: 'CUT_TWOSTEP_CUT_RPM_Index',
  7006: 'CUT_REVLIMITER_CTRL_Index',
  7007: 'CUT_EXTERN_LIMIT_Index',
  7008: 'CUT_DRVSHFTLIMITER_Index',
  7009: 'CUT_THREESTEP_CUT_RPM_Index',
  7010: 'CUT_MSDCUTSECURE_RPM_Index',
  7011: 'CUT_WHEELIE_CTRL',
  7012: 'CUT_DAVIS_CTRL',
  7013: 'CUT_GEARCHANGEOUT_CTRL',
  7014: 'CUT_GEARCHANGE_CTRL',
  7015: 'CUT_PITLIMIT_CTRL',
  7016: 'CUT_TRACTION_CTRL',
  7017: 'CUT_ALS_CTRL',
  7018: 'CUT_GEARCHGMNGR_CTRL',
  60000: 'Boost_RetardIndex',
  60001: 'Boost_EnrichIndex',
  61000: 'OdometerTotalIndex',
  61001: 'OdometerPartialIndex',
  61002: 'HourmeterTotalIndex',
  61003: 'HourmeterPartialIndex',
  65510: 'Inputshaft_Compensed_Math',
  65511: 'Boost_FuelFlow_Math',
  65512: 'FuelFlow_RPM_Math',
  65513: 'Flywheel_Clutch_Slip_Math',
  65514: 'Flywheel_RPM_Math',
  65515: 'FuelDiffPress_Math',
  65516: 'FuelFlowTotal_Math',
  65517: 'EGT_Average_Math',
  65518: 'Clutch_Slip_Math',
  65519: 'DiffSpeed_Math',
  65520: 'ProNitroStage_Index',
  65521: 'Accel_200HZ_Math',
  65522: 'Accel_100HZ_Math',
  65523: 'Accel_50HZ_Math',
  65524: 'Accel_25HZ_Math',
  65525: 'Accel_5HZ_Math',
  65526: 'Rpm_InputshaftBySpeed_Math',
  65527: 'Rpm_InputshaftByDriveShaft_Math',
  65528: 'Distance_Math',
  65529: 'FlowProNitro',
  65530: 'FlowBankA',
  65531: 'FlowBankB',
  65532: 'Rpm_Driveshaft_Math',
  65533: 'DutyBankA',
  65534: 'DutyBankB',
};
